const it = {
  common: {
    photo: 'Foto',
    continue: 'Continua',
    dragToReorder: 'Trascina per riordinare', dragToMove: 'Trascina per spostare',
    select: "Seleziona", noResults: "Nessun risultato",
    save: 'Salva', cancel: 'Annulla', edit: 'Modifica', delete: 'Elimina', add: 'Aggiungi',
    back: 'Indietro', close: 'Chiudi', copy: 'Copia', copied: 'Copiato!',
    loadingApp: 'Caricamento di Gromly',
    loading: 'Caricamento…', search: 'Cerca', open: 'Apri', confirm: 'Conferma',
    enable: 'Abilita', disable: 'Disabilita', create: 'Crea', invite: 'Invita',
    remove: 'Rimuovi', generate: 'Genera',
    fromDocument: 'Dal documento', fromDocumentHint: 'Importato dal tuo documento — è la tua base fissa. L\'assistente costruisce attorno senza riorganizzarla né rimuoverla.',
    deleting: 'Eliminazione…', required: 'Obbligatorio', confirmDelete: 'Sei sicuro? Questa azione non può essere annullata.',
    clear: 'Cancella', today: 'Oggi',
    pickTime: 'Scegli un orario', pickDate: 'Scegli una data', pickDateTime: 'Scegli data e ora', time: 'Ora', done: 'Fatto',
    areYouSure: 'Sicuro?', yesDelete: 'Sì, elimina', deleteFailed: 'Impossibile eliminare',
    accept: 'Accetta', discard: 'Ignora', ai: 'IA', or: 'o',
    error: 'Si è verificato un errore', saving: 'Salvataggio…',
  },
  upload: {
    fileTooLarge: '“{{name}}” è troppo grande: il limite è {{size}}',
    fileUnsupported: '“{{name}}” non è un tipo di file supportato',
    imageUnreadable: 'Non siamo riusciti a leggere la foto “{{name}}”. Prova a esportarla in JPEG.',
    storageFull: "Hai raggiunto il limite di spazio per le foto",
    storageFullBatch_one: "Hai raggiunto il limite di spazio per le foto: {{count}} foto non è stata caricata",
    storageFullBatch_other: "Hai raggiunto il limite di spazio per le foto: {{count}} foto non sono state caricate",
    progress: { title: "Caricamento foto {{current}} di {{total}}", keepOpen: "Tieni aperta questa pagina finché non finisce" },
  },
  nav: {
    myTrips: 'I miei viaggi', menu: 'Menu', docs: 'Docs', signOut: 'Esci', security: 'Sicurezza', agencyHome: "Home", collapseMenu: "Comprimi menu", expandMenu: "Espandi menu", agencyTrips: "Viaggi", mode: { label: "Passa a", personal: "I miei viaggi", admin: "Amministrazione" }, explore: 'Esplora', accountSettings: 'Impostazioni account',
    lightMode: 'Passa alla modalità chiara', darkMode: 'Passa alla modalità scura', language: 'Lingua',
  },
  auth: {
    unverified: {
      title: 'Verifica la tua email',
      body: 'Ti abbiamo inviato un link a {{email}}. Alcune azioni (invitare, pubblicare) sono bloccate finché non lo confermi.',
      resend: 'Reinvia',
      resent: 'Email reinviata. Controlla la tua casella.',
      alreadyVerified: 'La tua email è già verificata, ricarica la pagina.',
      resendFailed: 'Impossibile reinviare. Riprova tra qualche minuto.',
    },
    login: {
      heroTitle: 'Pianifica ogni\naventura',
      heroSubtitle: "Itinerari, prenotazioni, spese e le piccole note che il tuo gruppo ricorderà — tenuti in un posto tranquillo, condivisi solo con chi parte.",
      heroFeatures: { flights: 'Voli', hotels: 'Hotel', places: 'Luoghi', expenses: 'Spese', checklists: 'Liste', share: 'Condividi' },
      heroEyebrow: 'Dove inizia ogni viaggio',
      heroLine1: 'Pianifica', heroLine2: "l'indimenticabile,", heroLine3: 'dimentica il', heroLine4: 'resto.',
      title: 'Bentornato', subtitle: 'Accedi al tuo account',
      email: 'Email', password: 'Password', submit: 'Accedi',
      noAccount: 'Nessun account?', createOne: 'Creane uno',
      errorDefault: 'Email o password non validi',
      googleAccount: 'Questo account accede con Google. Sceglilo nel selettore account, oppure imposta una password.',
      appleAccount: 'Questo account accede con Apple. Usa «Continua con Apple», oppure imposta una password.',
      setPassword: 'Imposta una password per questo account',
      tooManyAttempts: 'Troppi tentativi. Aspetta qualche minuto e riprova.',
      hidePassword: 'Nascondi password', showPassword: 'Mostra password',
      breadcrumb: 'Account · accedi',
      newHere: 'Nuovo qui?',
      createAccount: 'Crea un account',
      continueJourney: 'Continua il tuo viaggio.',
      continueSubtitle: 'Accedi per riprendere da dove hai lasciato — i tuoi viaggi sono dove li hai lasciati.',
      forgot: 'Dimenticata?',
      passwordPlaceholder: 'Minimo 8 caratteri',
      rememberMe: 'Mantienimi connesso su questo dispositivo',
      orContinueWith: 'o continua con',
      continueWithGoogle: 'Continua con Google',
      continueWithApple: 'Continua con Apple',
      footer: { privacy: 'Privacy', terms: 'Termini', status: 'Stato', copyright: '© 2026 Gromly · Vestigi Platform, S.L.' },
    },
    forgotPassword: {
      eyebrow: 'Recupero account',
      title: 'Hai dimenticato la password?',
      subtitle: 'Scrivi l\'email con cui ti sei registrato e ti manderemo un link per sceglierne una nuova.',
      emailLabel: 'Indirizzo email',
      submit: 'Invia il link',
      failed: "Non siamo riusciti a inviare l'email. Riprova tra qualche minuto.",
      sentTitle: 'Controlla la posta',
      sentBody: 'Se {{email}} ha un account con noi, il link è già in viaggio.',
      sentHint: 'Il link scade tra un\'ora e si può usare una volta sola. Non lo trovi? Guarda nello spam.',
      backToLogin: "Torna all'accesso",
    },
    resetPassword: {
      eyebrow: 'Nuova password',
      title: 'Scegli una nuova password',
      subtitle: 'Sceglila facile da ricordare: ti servirà anche per accedere dagli altri dispositivi.',
      checking: 'Controllo del link…',
      newPassword: 'Nuova password',
      confirmPassword: 'Ripeti la password',
      confirmPlaceholder: 'Scrivila di nuovo',
      tooShort: 'Almeno {{min}} caratteri.',
      mismatch: 'Le due password non coincidono.',
      submit: 'Cambia password',
      failed: 'Non siamo riusciti a cambiare la password. Riprova.',
      twoFactorNeeded: "Questo account ha l'autenticazione a due fattori. Inserisci il codice per continuare.",
      twoFactorHint: "Quello della tua app di autenticazione, lo stesso che usi per accedere.",
      invalidTitle: 'Questo link non funziona più',
      invalidBody: "I link scadono dopo un'ora e si possono usare una volta sola. Chiedine uno nuovo, arriva in pochi secondi.",
      requestNew: 'Richiedi un nuovo link',
      doneTitle: 'Password cambiata',
      doneBody: 'Ti abbiamo disconnesso da tutti gli altri dispositivi. Accedi con la nuova password e riprendi da dove eri.',
      goToLogin: "Vai all'accesso",
    },
    twoFactor: {
      title: 'Autenticazione a due fattori',
      subtitle: "Inserisci il codice a 6 cifre dall'app di autenticazione",
      codeLabel: 'Codice di autenticazione',
      verify: 'Verifica',
      back: 'Torna al login',
      invalidCode: 'Codice non valido o scaduto',
      modalTitle: 'Autenticazione a due fattori',
      statusEnabled: "La 2FA è attiva. Il tuo account è protetto con un'app di autenticazione.",
      statusDisabled: 'La 2FA è disattivata. Attivala per aggiungere un livello di sicurezza extra.',
      enable: 'Attiva 2FA',
      disable: 'Disattiva 2FA',
      scanQr: 'Scansiona questo QR code con Google Authenticator, Authy o qualsiasi app TOTP.',
      manualEntry: 'Oppure inserisci questo segreto manualmente:',
      confirm: 'Attiva 2FA',
      confirmDisable: 'Disattiva 2FA',
      disablePrompt: 'Inserisci il tuo codice di autenticazione attuale per disattivare la 2FA.',
      setupError: 'Impossibile avviare la configurazione 2FA. Riprova.',
    },
    register: {
      nationality: "Nazionalità",
      heroTitle: 'La tua prossima\naventura ti aspetta',
      heroSubtitle: "Crea un account e inizia a pianificare\nviaggi indimenticabili con le tue persone.",
      heroFeatures: ['Costruttore di itinerari giorno per giorno', 'Spese condivise e debiti', 'Luoghi, prenotazioni e mappe', 'Invita compagni di viaggio'],
      heroEyebrow: 'La tua prossima avventura inizia qui',
      heroLine1a: 'Ogni grande ', heroLine1b: 'viaggio', heroLine2a: 'inizia con un ', heroLine2b: 'piano.',
      heroSubheading: 'Costruisci itinerari, dividi le spese e mantieni tutti i dettagli del viaggio in un posto tranquillo — condiviso solo con chi parte.',
      title: 'Crea account', subtitle: 'Inizia a pianificare i tuoi viaggi',
      displayName: 'Nome visualizzato', username: 'Nickname', email: 'Email', password: 'Password',
      passwordPlaceholder: 'Minimo 8 caratteri', submit: 'Crea account',
      hasAccount: 'Hai già un account?', signIn: 'Accedi',
      errorDefault: 'Registrazione fallita',
      hidePassword: 'Nascondi password', showPassword: 'Mostra password',
      invitePreview: 'Dopo aver creato il tuo account ti uniremo al viaggio "{{tripName}}" di {{inviterName}}.',
      mustAcceptTerms: 'Devi accettare i termini e la politica di privacy per continuare.',
      toastJoined: 'Ti sei unito al viaggio',
      toastInviteExpired: "Account creato, ma non abbiamo potuto aggiungerti al viaggio (invito scaduto)",
      toastVerifyEmail: 'Ti abbiamo inviato una email per verificare il tuo account',
      breadcrumb: 'Account · crea',
      alreadyMember: 'Già membro?',
      signInLink: 'Accedi',
      tripInviteHeader: 'Invito al viaggio',
      newAccountHeader: 'Nuovo account',
      startAdventure: 'Inizia la tua avventura.',
      createSubtitle: 'Crea il tuo account e inizia a pianificare il tuo primo viaggio.',
      acceptStart: 'Ho letto e accetto i',
      terms: 'Termini del servizio',
      and: 'e la',
      privacy: 'Politica di privacy',
      or: 'o',
      orWithEmail: 'o con email',
    },
    verify: {
      checking: 'Verifica email…',
      success: 'Email verificata',
      failed: 'Non abbiamo potuto verificare',
      successBody: 'Il tuo account è attivo. Ora puoi invitare amici ai tuoi viaggi e pubblicare contenuti.',
      failedBody: 'Il link non è valido o è scaduto. Dal tuo profilo puoi richiedere un nuovo link.',
      goToDashboard: 'Vai alla dashboard',
      goHome: "Vai all'inizio",
    },
    completeProfile: {
      eyebrow: 'Un passo in più',
      title: 'Completa il tuo profilo.',
      subtitle: 'Scegli un nickname e accetta le nostre politiche per iniziare.',
      nicknameLabel: 'Nickname',
      nicknameHint: 'Minimo 3 caratteri. Lettere, numeri e trattino basso.',
      acceptStart: 'Ho letto e accetto i',
      terms: "Termini d'uso",
      and: 'e la',
      privacy: 'Politica di privacy',
      continue: 'Continua',
      mustAccept: 'Devi accettare i termini e la politica di privacy per continuare.',
      saveFailed: 'Impossibile salvare il profilo',
    },
    callback: {
      signingIn: 'Accesso in corso…',
    },
  },
  invite: {
    errors: {
      invalidTitle: 'Invito non valido',
      invalidBody: 'Il link non corrisponde a nessun invito attivo.',
      cancelledTitle: 'Invito annullato',
      cancelledBody: 'La persona che ti ha invitato ha annullato questo invito.',
      expiredTitle: 'Invito scaduto',
      expiredBody: 'Questo link è scaduto. Richiedi un nuovo invito.',
      usedTitle: 'Invito già usato',
      usedBody: 'Questo link è già stato utilizzato.',
      ownTitle: 'Sei già proprietario del viaggio',
      ownBody: "Questo link è pensato per un'altra persona. Se vuoi provare come si accetta un invito, aprilo in una finestra in incognito o con un altro account.",
      emailMismatchTitle: "Questo invito è per un'altra email",
      emailMismatchBody: "La tua agenzia l'ha inviato a un altro indirizzo. Accedi con l'email che le hai dato.",
      failedTitle: 'Qualcosa è andato storto',
      failedBody: "Non abbiamo potuto caricare l'invito. Riprova.",
    },
    joined: 'Ti sei unito al viaggio',
    goDashboard: 'Torna alla dashboard',
    goHome: "Vai all'inizio",
    eyebrow: 'Invito al viaggio',
    inviterText: '{{inviterName}} ti invita',
    toCollaborate: 'A collaborare al viaggio "{{tripName}}".',
    roleEditor: 'Editor',
    roleViewer: 'Solo lettura',
    joining: 'Unione al viaggio…',
    needAccount: "Per accettare hai bisogno di un account Gromly. Se è la tua prima volta, creane uno in 30 secondi. Se hai già un account, accedi.",
    createAndJoin: 'Crea account e unisciti',
    haveAccount: 'Ho già un account · accedi',
    expiresOn: 'Scade il {{date}}',
  },
  dashboard: {
    deleteTripAria: 'Elimina viaggio',
    greeting: { morning: 'Buongiorno', afternoon: 'Buon pomeriggio', evening: 'Buonasera' },
    title: 'Le tue avventure', tagline: 'Pianifica insieme. Viaggia meglio.', searchPlaceholder: 'Cerca viaggi…',
    newTrip: 'Nuovo viaggio', newTripShort: 'Nuovo', addTripHint: 'Aggiungi destinazione, date e viaggiatori',
    stats: { totalTrips: 'Totale viaggi', destinations: 'Destinazioni', upcoming: 'In arrivo', nights: 'Notti', avgBudget: 'Budget medio', subPast: '{{count}} passati', subUnique: 'uniche', subTotal: 'totale', subPerTrip: 'per viaggio', subCredits: 'crediti' },
    filter: { all: 'Tutti', upcoming: 'In arrivo', past: 'Passati' },
    sections: { following: 'Viaggi che segui', upcoming: 'In arrivo', past: 'Passati', horizon: "All'orizzonte", brewing: 'Viaggi in preparazione', alsoPlanning: 'Anche in pianificazione', pastKicker: 'Dove sei stato', pastTitle: 'Ricordi', memoryLane: 'Memory lane · già vissuti', seeAll: 'Vedi tutti i {{count}}' },
    eyebrow: { trips_one: '{{count}} viaggio', trips_other: '{{count}} viaggi', lived_one: '{{count}} vissuto', lived_other: '{{count}} vissuti' },
    summary: { label: 'Riepilogo', trips_one: '{{count}} viaggio', trips_other: '{{count}} viaggi', dests_one: '{{count}} destinazione', dests_other: '{{count}} destinazioni', nights_one: '{{count}} notte', nights_other: '{{count}} notti', avg: '{{amount}} media', credits: '{{credits}} crediti' },
    toast: {
      loadFailed: 'Impossibile caricare i viaggi',
      deleted: 'Viaggio eliminato',
      published: 'Viaggio pubblicato nella community!',
      unpublished: 'Viaggio rimosso dalla community',
    },
    welcome: {
      title: 'Benvenuto su Gromly!',
      body: 'Abbiamo creato un viaggio di esempio a Barcellona per farti esplorare tutte le funzionalità. Eliminalo quando sei pronto.',
      explore: 'Esplora il demo →',
      create: 'Crea il mio primo viaggio',
    },
    community: {
      removeTitle: 'Rimuovi dalla community',
      shareTitle: 'Condividi il viaggio con la community',
      removeBody: '{{name}} non sarà più visibile agli altri viaggiatori.',
      shareBody: '{{name}} sarà pubblicato nel feed della community e visibile a tutti su Gromly.',
      remove: 'Rimuovi',
      publish: 'Pubblica viaggio',
      shared: 'Condiviso',
      share: 'Condividi',
      community: 'Community',
    },
    hero: {
      onRoadNow: 'In viaggio ora',
      nextAdventure: 'La tua prossima avventura',
      departingIn: 'Inizia tra',
      day: 'giorno',
      days: 'giorni',
      daysLeft: 'Giorni rimanenti',
      left: 'rimanenti',
      onRoad: 'In viaggio',
      planning: 'In pianificazione',
      night: 'notte',
      nights: 'notti',
      openItinerary: "Apri l'itinerario",
      fieldDestination: 'Destinazione',
      fieldDates: 'Date',
      fieldTravelers: 'Viaggiatori',
      people_one: '{{count}} persona',
      people_other: '{{count}} persone',
    },
    card: {
      active: 'In corso',
      tomorrow: 'Domani',
      inDays_one: 'tra {{count}} giorno',
      inDays_other: 'tra {{count}} giorni',
    },
    today: 'Oggi!', tomorrow: 'Domani', daysUntil: '{{count}}g', pastLabel: 'Passato',
    delete: 'Elimina', open: 'Apri',
    deleteTrip: { title: 'Eliminare questo viaggio?', body: '"{{name}}" e tutto il suo itinerario, luoghi, spese e prenotazioni verranno eliminati permanentemente.' },
    empty: {
      kicker: 'Inizia qui',
      title: 'Pianifica il tuo primo viaggio',
      subtitle: 'Crea un viaggio, invita il tuo compagno di avventura e inizia a organizzare itinerario, luoghi, spese e checklist — tutto in un posto.',
      cta: 'Nuovo viaggio',
      exploreCta: 'Esplora i viaggi',
      featuresLabel: 'Funzionalità',
      features: [
        { label: 'Itinerario giorno per giorno', desc: 'Attività, orari e ordine' },
        { label: 'Luoghi e mappa', desc: 'Salva i posti e vedi il percorso' },
        { label: 'Pianifica con IA', desc: 'L’IA prepara il tuo viaggio' },
        { label: 'Voli e hotel', desc: 'Prenotazioni e biglietti insieme' },
        { label: 'Spese condivise', desc: 'Liquidazione automatica dei debiti' },
        { label: 'Pianificate in team', desc: 'Invita e pianificate insieme' },
        { label: 'Liste e valigia', desc: 'Documenti e checklist valigia' },
        { label: 'Galleria foto', desc: 'I vostri ricordi, giorno per giorno' },
      ],
    },
    modalTitle: 'Pianifica un nuovo viaggio',
    newTripWizard: {
      progress: "Passo {{current}} di {{total}}",
      back: "Indietro",
      stepLabel: {
        destination: "Destinazione",
        dates: "Date",
        legs: "Notti",
        travellers: "Viaggiatori",
        bookings: "Prenotazioni",
        start: "Come iniziamo",
        documents: "Documenti",
        style: "Il vostro stile",
        summary: "Riepilogo",
      },
      ask: {
        destination: "Dove vai?",
        dates: "Quando?",
        legs: "Quante notti in ogni posto?",
        travellers: "Chi viene?",
        bookings: "Hai già delle prenotazioni?",
        start: "Come vuoi iniziare?",
        documents: "Carica quello che hai già",
        style: "Come vi piace viaggiare a {{destination}}?",
        summary: "Il tuo viaggio è pronto a partire",
      },
      hint: {
        destination: "Una città, una regione o un intero paese. Ne visiti diversi? Aggiungili uno alla volta.",
        legs: "Devono sommare le notti del viaggio.",
        travellers: "Aggiungi tutti quelli che viaggiano: dal primo giorno potrete dividere spese, voli e valigia.",
        bookings: "Voli, alloggio, trasporti o biglietti, divisi per tipo. Li leggiamo e li aggiungiamo a Docs con il file allegato. Ogni tipo usa un credito IA.",
        start: "Potrai cambiare tutto in seguito.",
        documents: "Prenotazioni, biglietti o un itinerario in PDF, Word o Excel. Non si aggiunge nulla finché non confermi.",
        style: "Perché i suggerimenti siano su misura per te.",
        summary: "Controlla e dagli un nome.",
      },
      travellersCount_one: "Solo io",
      travellersCount_other: "Siamo in {{count}}",
      travellersFewer: "Uno in meno",
      travellersMore: "Uno in più",
      travellerDefaultName: "Viaggiatore {{number}}",
      ticketsCount_one: "{{count}} prenotazione",
      ticketsCount_other: "{{count}} prenotazioni",
      ticketsNone: "Nessuna",
      ticketsSkip: "Salta",
      ticketsMax: "Fino a {{count}} file per tipo.",
      ticketsAddTo: "Aggiungi file a {{kind}}",
      travellerName: "Nome",
      travellerRemove: "Rimuovi viaggiatore",
      you: "tu",
      birthDateLabel: "Data di nascita (facoltativa)",
      birthDateHint: "Facoltativa. Con la data di nascita potremo avvisarti di tariffe e vantaggi in base all'età e adattare meglio il piano a chi viaggia.",
      emailLabel: "Email",
      emailPlaceholder: "nome@email.com",
      emailHint: "Gli invieremo un invito a unirsi al viaggio.",
      addEmail: "Invita via email",
      start: {
        recommended: "Consigliato",
        ai: {
          title: "Pianificalo con l'IA",
          description: "Ti proponiamo luoghi, un itinerario giorno per giorno e consigli pratici.",
        },
        documents: {
          title: "Ho dei documenti",
          description: "Carica prenotazioni o un itinerario e costruiamo il viaggio da lì.",
        },
        empty: {
          title: "Parto da zero",
          description: "Crea il viaggio vuoto e riempilo con calma.",
        },
      },
      documentsFound: "Ecco cosa abbiamo trovato",
      complementAi: "Completa con l'IA quello che manca",
      complementAiHint: "Aggiungiamo luoghi e itinerario attorno a ciò che i tuoi documenti già coprono.",
      paceLabel: "Ritmo",
      budgetLabel: "Budget",
      interestsLabel: "Cosa vi va di fare?",
      notesLabel: "Altro? (facoltativo)",
      generatingTitle: "Stiamo preparando il tuo viaggio",
      invitesFailed_one: "Non è stato possibile inviare un invito: puoi inviarlo da Partecipanti.",
      invitesFailed_other: "Non è stato possibile inviare {{count}} inviti: puoi inviarli da Partecipanti.",
      groupForPrompt_one: "una persona che viaggia da sola",
      groupForPrompt_other: "un gruppo di {{count}} (le età sono nella lista dei viaggiatori)",
      destinationPlaceholder: 'Es: Lisbona, Portogallo',
      destinationAddAnother: "Aggiungi un’altra destinazione",
      destinationRemove: "Rimuovi {{name}}",
      legNights_one: "{{count}} notte",
      legNights_other: "{{count}} notti",
      legNightsFewer: "Una notte in meno a {{name}}",
      legNightsMore: "Una notte in più a {{name}}",
      legsTotal_one: "{{assigned}} di {{count}} notte",
      legsTotal_other: "{{assigned}} di {{count}} notti",
      legDays: "Giorni {{from}}–{{to}}",
      legDay: "Giorno {{day}}",
      legDaysShort: "giorni {{from}}–{{to}}",
      legForPrompt_one: "{{name}} ({{count}} notte)",
      legForPrompt_other: "{{name}} ({{count}} notti)",
      datesPlaceholder: "Es: dal 3 al 10 agosto, o 'la prima settimana di settembre'",
      datesParseFailed: 'Non ho capito bene quelle date — puoi riformularle?',
      datesPickHint: 'oppure scegli le date nel calendario qui sotto',
      datesAnswer_one: '{{start}} – {{end}} · {{count}} notte',
      datesAnswer_other: '{{start}} – {{end}} · {{count}} notti',
      preferencesPlaceholder: 'Es: ritmo rilassato, adoriamo la cucina locale...',
      interestsLoading: 'Sto scoprendo cosa fa di solito la gente qui…',
      interestsFailed: 'Non è stato possibile caricare suggerimenti per questa destinazione — puoi comunque continuare.',
      pace: { relaxed: 'Rilassato', balanced: 'Equilibrato', packed: 'Intenso' },
      budget: { budget: 'Economico', mid: 'Fascia media', splurge: 'Senza limiti' },
      nameLabel: 'Nome del viaggio',
      currencyLabel: 'Valuta base',
      currencyHint: 'I saldi e il budget sono mostrati in questa valuta; le spese in altre valute vengono convertite in essa.',
      defaultName: 'Viaggio a {{destination}}',
      next: 'Continua',
      editAnswer: 'Modifica risposta',
      importFromDocument: 'Importa da documenti',
      documentsRemove: "Rimuovi documenti",
      importing: 'Lettura del tuo documento…',
      importFailed: 'Non siamo riusciti a leggere il documento — prova con un altro file o continua manualmente.',
      importInsufficientCredits: 'Hai esaurito i crediti IA — puoi comunque creare il viaggio manualmente.',
      create: 'Crea viaggio', created: 'Viaggio creato!', failed: 'Impossibile creare il viaggio',
      noSpecificInterests: 'nessun interesse specifico indicato',
      placesSeedPrompt: 'Stiamo pianificando un viaggio di {{nights}} notti a {{destination}} con ritmo {{pace}}, per {{travelers}}, budget {{budget}}. Siamo particolarmente interessati a: {{interests}}. {{notes}} Suggerisci circa {{targetCount}} posti fantastici adatti a questo — un mix degli interessi sopra più un paio di buoni ristoranti o caffè nelle vicinanze.',
      itinerarySeedPrompt: 'Organizza tutti i posti che hai appena salvato in un itinerario completo giorno per giorno per tutto il viaggio, mantenendo un ritmo {{pace}}.',
      tipsSeedPrompt: "Dammi i consigli più essenziali e pratici per viaggiare a {{destination}} — requisiti d'ingresso (visto, ETA, ESTA…), vaccinazioni consigliate o precauzioni sanitarie, assicurazione di viaggio, e qualsiasi altro consiglio locale davvero utile.",
      generating: {
        stepPlaces: 'Luoghi a {{destination}}',
        stepPlacesFound_one: '{{count}} trovato',
        stepPlacesFound_other: '{{count}} trovati',
        stepItinerary_one: 'Il tuo itinerario di {{count}} notte',
        stepItinerary_other: 'Il tuo itinerario di {{count}} notti',
        stepItineraryDone_one: '{{count}} giorno',
        stepItineraryDone_other: '{{count}} giorni',
        stepTips: 'Consigli pratici per {{destination}}',
        stepTipsDone_one: '{{count}} consiglio',
        stepTipsDone_other: '{{count}} consigli',
        stepTickets: "Le tue prenotazioni",
        stepTicketsDone_one: "{{count}} aggiunta",
        stepTicketsDone_other: "{{count}} aggiunte",
        ticketsUnplaced_one: "Non siamo riusciti a leggere {{count}} documento: è salvato in Note per aggiungerlo da Docs.",
        ticketsUnplaced_other: "Non siamo riusciti a leggere {{count}} documenti: sono salvati in Note per aggiungerli da Docs.",
        dayStops_one: 'Giorno {{number}} · {{count}} tappa',
        dayStops_other: 'Giorno {{number}} · {{count}} tappe',
        doneEmpty: 'Viaggio creato — puoi aggiungere posti quando vuoi dalla scheda Luoghi.',
        errorCredits: 'Crediti IA esauriti — il tuo viaggio è stato creato, ma questa volta non siamo riusciti a generare suggerimenti.',
        errorUnknown: 'Qualcosa è andato storto generando i suggerimenti — il tuo viaggio è stato comunque creato.',
        cta: 'Vedi il mio viaggio',
      },
    },
  },
  birthDate: {
    day: "Giorno",
    month: "Mese",
    year: "Anno",
  },
  import: {
    sidebarButton: 'Importa documento',
    title: 'Importa da documenti',
    description: 'Carica un file Word, PDF, Excel o di testo con il tuo piano ed estrarremo i luoghi e l\'itinerario giorno per giorno. Non viene aggiunto nulla finché non confermi.',
    dropHint: 'Fai clic per scegliere i file',
    addMore: 'Aggiungi altri file',
    analyze_one: 'Analizza {{count}} documento',
    analyze_other: 'Analizza {{count}} documenti',
    formats: 'PDF, Word, Excel, CSV o immagini · fino a 10 file',
    extracting: 'Lettura dei tuoi documenti…',
    docProgress: "Documento {{current}} di {{total}}",
    reviewHint: 'Scegli cosa aggiungere al viaggio. Gli elementi esistenti non vengono mai modificati.',
    savedDocsNote: 'Documenti importati',
    language: {
      title: 'Il documento è in {{document}}',
      hint: 'Il tuo viaggio è in {{trip}}. Traduci ciò che importi così tutto il viaggio parla una sola lingua. I nomi dei luoghi restano invariati.',
      action: 'Traduci in {{trip}}',
      done: 'Contenuto tradotto nella lingua del viaggio',
      failed: 'Impossibile tradurre. Puoi aggiungerlo così com\'è.',
    },
    placesSection_one: '{{count}} luogo',
    placesSection_other: '{{count}} luoghi',
    daySection: 'Giorno {{number}}',
    daySectionNoNumber: 'Itinerario',
    activitiesSection_one: "{{count}} attività",
    activitiesSection_other: "{{count}} attività",
    packingCount_one: "{{count}} oggetto in valigia",
    packingCount_other: "{{count}} oggetti in valigia",
    flightsSection_one: '{{count}} volo',
    flightsSection_other: '{{count}} voli',
    hotelsSection_one: '{{count}} alloggio',
    hotelsSection_other: '{{count}} alloggi',
    nightsCount_one: '{{count}} notte',
    nightsCount_other: '{{count}} notti',
    bookingsSection_one: '{{count}} prenotazione',
    bookingsSection_other: '{{count}} prenotazioni',
    tipsSection_one: '{{count}} consiglio',
    tipsSection_other: '{{count}} consigli',
    packingSection: 'Valigia · {{section}}',
    expensesSection_one: '{{count}} spesa',
    expensesSection_other: '{{count}} spese',
    addSelected_one: 'Aggiungi {{count}} elemento',
    addSelected_other: 'Aggiungi {{count}} elementi',
    added_one: '{{count}} elemento aggiunto',
    added_other: '{{count}} elementi aggiunti',
    mapsQuotaWarning: 'Questa volta non siamo riusciti a localizzare alcuni luoghi sulla mappa, ma sono stati comunque importati.',
    errors: {
      nothingFound: 'Non abbiamo trovato luoghi o itinerari in questo documento.',
      extractFailed: 'Non siamo riusciti a leggere il documento — prova con un altro file.',
      insufficientCredits: 'Hai esaurito i crediti IA.',
      rateLimited: 'Stiamo ricevendo molte richieste in questo momento. Attendi qualche secondo e riprova.',
      saveFailed: 'Qualcosa è andato storto durante l\'aggiunta degli elementi — riprova.',
    },
  },
  trip: {
    editName: 'Clicca per rinominare il viaggio',
    renameFailed: 'Impossibile rinominare il viaggio',
    destinations: {
      title: "Destinazioni", edit: "Cambia destinazioni",
      hint: "I posti che il viaggio visita, in ordine, e quante notti in ciascuno.",
      saved: "Destinazioni aggiornate", failed: "Impossibile cambiare le destinazioni",
      moveUp: "Sposta su {{name}}", moveDown: "Sposta giù {{name}}",
    },
    dates: {
      title: 'Date del viaggio', edit: 'Cambia le date', confirm: 'Applica',
      saved: 'Date aggiornate', failed: 'Impossibile cambiare le date',
      willMove_one: 'Il viaggio si accorcia. 1 tappa del giorno {{from}} passa al giorno {{to}}.',
      willMove_other: 'Il viaggio si accorcia. {{count}} tappe del giorno {{from}} passano al giorno {{to}}.',
      willLoseMeals_one: '1 pasto pianificato nei giorni che spariscono andrà perso — i pasti se ne vanno con il loro giorno.',
      willLoseMeals_other: '{{count}} pasti pianificati nei giorni che spariscono andranno persi — i pasti se ne vanno con il loro giorno.',
      willLoseOutfits_one: "I vestiti previsti per 1 giorno che sparisce andranno persi — restano in valigia.",
      willLoseOutfits_other: "I vestiti previsti per {{count}} giorni che spariscono andranno persi — restano in valigia.",
      willAdd_one: 'Viene aggiunto un giorno vuoto alla fine.', willAdd_other: 'Vengono aggiunti {{count}} giorni vuoti alla fine.',
      noLoss_one: 'Il viaggio mantiene il suo giorno, nella nuova data.', noLoss_other: 'I {{count}} giorni mantengono le loro tappe, nelle nuove date.',
      bookingsOutside_one: '1 prenotazione cade fuori dalle nuove date', bookingsOutside_other: '{{count}} prenotazioni cadono fuori dalle nuove date',
      bookingsKept: 'Mantengono la loro data: un codice di prenotazione è un fatto, quindi non si sposta nulla al posto tuo.',
      aFlight: 'Volo',
    },
    nav: {
      itinerary: 'Itinerario', places: 'Luoghi', map: 'Mappa',
      bookings: 'Prenotazioni', expenses: 'Spese', meals: 'Pasti', packing: 'Valigia', info: 'Consigli',
      plan: 'Piano', placesShort: 'Luoghi', mapShort: 'Mappa',
      docsShort: 'Docs', money: 'Soldi', mealsShort: 'Pasti', packingShort: 'Valigia', infoShort: 'Consigli',
      notes: 'Note', notesShort: 'Note',
      services: 'Servizi', servicesShort: 'Servizi',
      gallery: 'Diario', galleryShort: 'Diario', album: 'Album',
      more: 'Altro',
    },
    sidebar: {
      allTrips: 'Tutti i viaggi', sections: 'Sezioni', documentation: 'Documentazione', collapse: 'Riduci', expand: 'Espandi',
      nights_one: '{{count}} notte', nights_other: '{{count}} notti',
      flights_one: '{{count}} volo', flights_other: '{{count}} voli',
      people: '{{count}} persone',
      manage: 'Gestisci',
      workspace: 'Area di lavoro',
      travellers_one: 'viaggiatore',
      travellers_other: 'viaggiatori',
      underway: 'In corso',
      tomorrow: 'Domani',
      inDays: 'In {{count}} giorni',
      ready: '{{pct}}% pronto',
      exportPdf: 'Esporta PDF',
      generating: 'Generazione…',
      exportFailed: 'Impossibile generare il PDF',
    },
    cover: {"title": "Foto di copertina", "hint": "Appare sulla scheda e nell'intestazione del viaggio. Inquadratura 3:2.", "add": "Carica una foto", "remove": "Torna alla copertina automatica", "cropTitle": "Inquadra la copertina", "save": "Salva copertina", "saved": "Copertina aggiornata", "removed": "Torna la copertina automatica", "failed": "Impossibile aggiornare la copertina", "unsupported": "Questo file non è una foto utilizzabile", "alt": "Copertina del viaggio", "changeAction": "Cambia la copertina"},
    contentLanguage: {
      title: 'Lingua del viaggio',
      hint: "La lingua in cui l'assistente scrive i contenuti del viaggio: luoghi, itinerario, consigli e valigia. Vale solo per i contenuti nuovi; quelli già salvati restano come sono.",
      saved: 'Lingua del viaggio aggiornata',
      failed: 'Impossibile aggiornare la lingua del viaggio',
    },
    manage: { title: 'Gestisci il viaggio' },
    participants: {
      roles: { OWNER: 'Proprietario', EDITOR: 'Editor', VIEWER: 'Lettore' },
      title: 'Partecipanti al viaggio',
      you: '(tu)',
      pending: 'Inviti in sospeso',
      invite: 'Invita qualcuno tramite email',
      sendInvitation: 'Invita',
      hint: 'Riceverà un’email con un link per unirsi. Entrambi i ruoli contano come viaggiatori: condividono le spese e hanno la propria valigia.',
      viewerHint: 'Solo il proprietario del viaggio può invitare o rimuovere i viaggiatori.',
      roleEditor: 'Editor · viaggia e modifica',
      roleViewer: 'Sola lettura · viaggia, non modifica',
      remove: 'Rimuovi',
      cancelInvite: 'Annulla',
      roleLabel: 'Ruolo: {{role}} · Scade',
      age_one: "{{count}} anno",
      age_other: "{{count}} anni",
      placeholder: {
        addBirthDate: "Aggiungi data di nascita",
        editBirthDate: "Cambia data di nascita",
        noAccount: 'Senza account',
        addTitle: 'Aggiungi qualcuno senza account',
        addHint: "Per chi non si è ancora registrato: puoi mettere a suo nome spese, voli e cose della valigia, e collegarlo al suo account più avanti.",
        namePlaceholder: 'Nome',
        add: 'Aggiungi',
        link: 'Collega a un account',
        inviteHint: "Mandagli un invito. Quando lo accetta, tutto ciò che è a suo nome passa al suo account.",
        mergeHint: 'È già nel viaggio con il suo account?',
        mergeSelect: 'Scegli chi è',
        merge: 'Unisci',
        confirmMergeTitle: 'Unire {{name}} a {{target}}?',
        confirmMergeBody: 'Tutto ciò che è assegnato a {{name}} — spese, debiti, voli e cose della valigia — passa a {{target}}. Non si può annullare.',
        invitationFor: 'per {{name}}',
        toast: {
          birthDateFailed: "Impossibile salvare la data di nascita",
          added: '{{name}} aggiunto al viaggio',
          addFailed: 'Impossibile aggiungerlo',
          merged: 'Uniti',
          mergeFailed: 'Impossibile unire',
        },
      },
      toast: {
        invited: 'Invito inviato',
        emailNotVerified: 'Verifica la tua email prima di invitare altri utenti',
        inviteFailed: "Impossibile inviare l'invito",
        revoked: 'Invito annullato',
        revokeFailed: "Impossibile annullare",
        removed: 'Partecipante rimosso',
        roleChanged: 'Ruolo aggiornato',
        roleChangeFailed: 'Impossibile aggiornare il ruolo',
      },
    },
    notifications: {
      reminder_one: '{{count}} promemoria in arrivo', reminder_other: '{{count}} promemoria in arrivo',
      title: 'Promemoria',
    },
    notFound: 'Viaggio non trovato',
    demo: {
      banner: 'Questo è un viaggio di esempio — esplora liberamente tutto.',
      deleteConfirm: 'Eliminare questo viaggio di esempio?',
      deleteFailed: 'Impossibile eliminare il viaggio di esempio',
    },
    tour: {
      start: 'Fai il tour',
      skip: 'Salta',
      back: 'Indietro',
      next: 'Avanti',
      finish: 'Ho capito',
      steps: {
        importDoc: {
          title: "Hai già il viaggio in un documento?",
          body: "Carica un Word, PDF o Excel — anche biglietti di volo o hotel — ed estraiamo luoghi, itinerario, prenotazioni e spese per te.",
        },
        welcome: {
          title: 'Benvenuto su Gromly 👋',
          body: 'Questo è un viaggio di esempio a Barcellona. Fai un tour veloce per scoprire tutto quello che puoi fare — puoi saltarlo quando vuoi.',
        },
        itinerary: {
          title: 'Pianifica il tuo itinerario',
          body: 'Organizza il viaggio giorno per giorno: aggiungi attività, imposta gli orari e trascina per riordinare.',
        },
        itineraryAi: {
          title: 'Ti presentiamo gIA, ovunque',
          body: 'Ora gIA ti accompagna in ogni schermata, agganciata qui a destra. Si adatta a dove ti trovi — itinerario, luoghi, prenotazioni, valigia o consigli — quindi basta espanderla per chiedere idee, un’intera giornata o di riorganizzare le cose. La tua conversazione ti segue quando cambi scheda.',
        },
        places: {
          title: 'Salva i luoghi da visitare',
          body: 'Raccogli ristoranti, monumenti e quartieri per categoria — e l’IA può suggerirti nuovi posti adatti al tuo viaggio.',
        },
        map: {
          title: 'Vedi tutto sulla mappa',
          body: 'I tuoi luoghi salvati e le attività di ogni giorno, tutto su un’unica mappa.',
        },
        mapRoutes: {
          title: 'I percorsi sulla mappa',
          body: 'Passa a «Percorsi» per vedere tutti i giorni selezionati insieme: tempi di viaggio, trasporto per tratta e «Ottimizza con gIA» per riordinare le tappe di un giorno.',
        },
        bookings: {
          title: 'Conserva le tue prenotazioni',
          body: 'Tieni voli, hotel e biglietti in un unico posto. Incolla una conferma e l’IA ne estrae i dettagli per te.',
        },
        expenses: {
          title: 'Traccia e dividi le spese',
          body: 'Annota le spese, imposta un budget e dividi i costi con i compagni di viaggio.',
        },
        balances: {
          title: 'Chi deve cosa',
          body: 'Gromly compensa tutte le spese condivise e ti dice esattamente chi deve cosa — senza calcoli.',
        },
        packing: {
          title: 'Valigia',
          body: 'Liste per la valigia e documenti per non dimenticare nulla — l’IA può crearti la lista in base a destinazione e date.',
        },
        tips: {
          title: 'Consigli',
          body: 'Consigli locali su trasporti, cibo e sicurezza — l’IA può generarli su misura per la tua destinazione.',
        },
        notes: {
          title: 'Note',
          body: 'Un blocco note condiviso per idee, link e tutto ciò che vuoi ricordare.',
        },
        gallery: {
          title: 'Galleria',
          body: 'Carica le foto del viaggio e sfogliale organizzate per giorno.',
        },
        finish: {
          title: 'Tutto pronto!',
          body: 'Questo è il tour. Esplora liberamente — questo viaggio di esempio è tuo per fare pratica, e puoi eliminarlo quando sei pronto a pianificare sul serio.',
        },
      },
    },
    share: {
      disable: 'Disabilita condivisione', enable: 'Abilita condivisione', creating: 'Creazione…',
      disabledToast: 'Condivisione disabilitata', enabledToast: 'Link di condivisione creato!',
      panelTitle: 'Mostrare il viaggio a chi non ci va',
      panelHint: 'Un link che apre il viaggio senza account. Chi lo apre non è un viaggiatore: non entra nella divisione per persona, non ha una valigia e non conta nel numero di viaggiatori. Scegli cosa si vede.',
      sectionsTitle: 'Cosa mostra il link',
      sectionsHint: 'Questo link è stato creato prima di queste opzioni, quindi mostra ancora quello di sempre. Spunta ciò che vuoi aggiungere.',
      photosWarning: 'I link alle foto continuano a funzionare una volta copiati, anche se lo disattivi di nuovo.',
      diaryHint: 'Ogni autore decide quali voci pubblicare. I follower si iscrivono via e-mail dal link. Disattivare il link li rimuove tutti.',
      section: {
        ITINERARY: 'Itinerario',
        NOTES: 'Note di tappe e luoghi',
        PLACES: 'Luoghi salvati',
        MAP: 'Mappa',
        MEALS: 'Pasti',
        TIPS: 'Consigli',
        PHOTOS: 'Foto',
        DIARY: 'Diario',
        BOOKINGS: 'Voli, alloggi e prenotazioni',
      },
    },
    story: {
      entry: 'Storia di Instagram',
      title: 'Storia di Instagram',
      upload: 'Carica una foto',
      background: 'Sfondo',
      gradient: { paper: 'Crema', ink: 'Nero' },
      framingHint: "Trascina per spostare la foto, usa la rotellina per ingrandirla",
      statDays: 'Giorni', statStops: 'Tappe', statDistance: 'Distanza',
      download: 'Scarica', share: 'Condividi',
      hint: 'Salva l\'immagine e caricala nella tua storia — 1080 × 1920.',
      previewAlt: 'Anteprima della storia',
      imageFailed: 'Impossibile caricare questa immagine', exportFailed: 'Impossibile creare l\'immagine',
    },
  },
  linkedDelete: { both: "Elimina entrambi" },
  itinerary: {
    stopPhotos_one: '{{count}} foto di questa tappa', stopPhotos_other: '{{count}} foto di questa tappa',
    // ADR-0039: a stop of the travellers' own, as agency staff see it.
    maskedStop: {
      title: "Programma dei viaggiatori",
      hint: "È loro: l'agenzia non vede di cosa si tratta.",
    },
    deleteLinked: {
      title_one: "Questa tappa è un pasto pianificato",
      title_other: "{{count}} di queste tappe sono pasti pianificati",
      body_one: "Eliminare anche il pasto da Pasti?",
      body_other: "Eliminare anche questi pasti da Pasti?",
      only_one: "Solo la tappa",
      only_other: "Solo le tappe",
    },
    suggestTime: {
      use: 'usa',
      hint: 'Calcolata dalla tappa precedente e dallo spostamento tra le due. Tocca per usarla.',
      noTravel: 'Calcolata dalla tappa precedente. Lo spostamento non è ancora conteggiato.',
    },
    schedule: {
      from: 'dalle',
      dayStart: 'La giornata inizia alle',
      setDayStart: 'Imposta un’ora di inizio',
      clear: 'Torna agli orari manuali',
      hint: 'Gli orari derivano da questo, dalla durata di ogni tappa e dagli spostamenti.',
      manual: 'Gli orari di questa giornata sono quelli che hai scritto tu.',
      estimated: 'stimata',
      noTravel: 'Spostamenti non ancora contati — calcolali e la giornata si ricolloca.',
      overrun: 'Non ci sta prima di questo orario fisso',
      locked: 'Orario fisso',
      timeMode: 'Tipo di orario',
      modeAuto: 'Calcolato',
      modeFixed: 'Fisso',
      autoHint: 'Si regola da solo in base all’ordine, alle durate e agli spostamenti.',
      fixedHint: 'Non si sposta anche se riordini la giornata.',
    },
    title: 'Itinerario',
    subtitle_one: '{{count}} giorno · {{nights}} notti',
    subtitle_other: '{{count}} giorni · {{nights}} notti',
    views: { list: 'Lista', timeline: 'Cronologia' },
    addDay: 'Aggiungi giorno',
    heading: 'Il piano',
    daysPlanned_one: '{{count}} giorno pianificato',
    daysPlanned_other: '{{count}} giorni pianificati',
    legend: { hasActivities: 'Ha attività', today: 'Oggi' },
    dayLabel: 'Giorno {{n}}',
    dayShort: 'G{{n}}',
    weather: {
      condition: { clear: 'Sereno', fair: 'Poco nuvoloso', partlyCloudy: 'Parzialmente nuvoloso', cloudy: 'Nuvoloso', fog: 'Nebbia', drizzle: 'Pioggia debole', rain: 'Pioggia', snow: 'Neve', thunder: 'Temporali' },
      typicalFor: 'tipico di {{month}}',
      aria: '{{condition}}, massima {{max}}°, minima {{min}}°',
      ariaTypical: 'Tipico di {{month}}: massima {{max}}°, minima {{min}}°',
      at: 'Misurato a {{place}}',
      atTrip: 'Misurato a {{place}} — la destinazione del viaggio, non una tappa di questo giorno',
      tripDestination: 'destinazione del viaggio',
      panel: {
        title: 'Ora per ora',
        subtitle: 'Come cambia il tempo in ogni giorno del viaggio',
        open: 'Vedi ora per ora',
        noHourly: 'Le previsioni orarie arrivano solo a circa 9 giorni.',
        noData: 'Nessun dato meteo per questo giorno.',
        blocksLegend: 'Oltre i ~3 giorni le previsioni danno solo quattro rilevazioni al giorno, mostrate così come sono. La curva oraria completa compare man mano che quei giorni si avvicinano.',
        beyondForecast: 'Oltre le previsioni',
        precip: '{{mm}} mm',
        wind: '{{kmh}} km/h',
      },
    },
    modal: { addActivity: 'Aggiungi attività', editActivity: 'Modifica attività', addToItinerary: 'Aggiungi all\'itinerario', addToDays: 'Aggiungi a {{count}} giorni', dayLabel: 'Giorno', addedToDay: 'Aggiunto al Giorno {{n}}', addedToDays: 'Aggiunto a {{count}} giorni', removedFromItinerary: 'Rimosso dall\'itinerario', itinerarySaved: 'Itinerario aggiornato', unassignHint: 'Deseleziona un giorno per rimuoverlo dall\'itinerario.', noDaysYet: 'Nessun giorno di itinerario.', noDaysDesc: 'Aggiungi giorni nella scheda Itinerario prima.' },
    ai: { open: 'Apri assistente IA', close: 'Chiudi assistente IA' },
    activities_one: '{{count}} attività',
    activities_other: '{{count}} attività',
    flight: { outbound: 'Andata', return: 'Ritorno' },
    fromBooking: 'Prenotazione',
    fromBookingHint: 'Viene da una prenotazione nella scheda Prenotazioni — modificala e tutte le notti si aggiornano.',
    hotel: { checkIn: 'Check-in', checkOut: 'Check-out', night: 'Notte' },
    continuesFrom: 'Continua da',
    startFromPrev: { active: 'Inizia qui', inactive: 'Parti da qui', disable: 'Smetti di continuare dal giorno precedente', lastOfPrevDay: 'Ultimo luogo del giorno prima' },
    optional: { badge: 'Opzionale', label: 'Tappa opzionale', hint: 'Se la giornata si complica, puoi saltarla senza problemi.', mark: 'Segna come opzionale', unmark: 'Segna come imperdibile' },
    openInMaps: 'Apri in Google Maps',
    openBooking: 'Apri il link di prenotazione',
    delete: { title: "Eliminare l'attività?", ariaLabel: 'Elimina attività', body: 'Questa azione non può essere annullata.', bodyLocked: "Questa attività è il punto di partenza del giorno successivo — eliminarla la rimuoverà anche da lì." },
    bulk: { selected_one: '{{count}} selezionata', selected_other: '{{count}} selezionate', delete: 'Elimina selezione', cancel: 'Annulla', select: 'Seleziona', move: 'Sposta in…', moveTo: 'Sposta al giorno', duplicate: 'Duplica in…', duplicateTo: 'Duplica al giorno', deleting: 'Eliminazione…' },
    stopCount_one: '{{count}} tappa', stopCount_other: '{{count}} tappe',
    legs: { calculate_one: 'Tempo di percorrenza ({{count}} tratta)', calculate_other: 'Tempi di percorrenza ({{count}} tratte)' },
    move: {
      dropOnDay: 'Rilascia su un giorno per spostarla',
      releaseOnDay: 'Rilascia per spostarla al giorno {{day}} · {{date}}',
      confirmTitle_one: 'Spostare «{{title}}» al giorno {{day}}?', confirmTitle_other: 'Spostare {{count}} tappe al giorno {{day}}?',
      confirm: 'Sposta',
      moved_one: 'Spostata al giorno {{day}}', moved_other: '{{count}} tappe spostate al giorno {{day}}',
      duplicated_one: 'Copia creata', duplicated_other: '{{count}} copie create',
      failed: 'Impossibile spostarla', duplicateFailed: 'Impossibile duplicarla',
      errorOrigin: 'La scheda «continua da» segue il giorno precedente: non può essere spostata da sola.',
      errorStayNight: 'Una notte di soggiorno non ha una data propria: modifica le date della prenotazione.',
      errorBookingCard: 'Una scheda generata da una prenotazione non può essere duplicata; duplica la prenotazione.',
    },
    form: {
      titleField: 'Titolo', titlePlaceholder: 'es. Pranzo all\'Alfama',
      yourTypes: 'I tuoi tipi', newType: '+ Nuovo tipo…', newTypeName: 'Nome del tipo', newTypePlaceholder: 'es. Snorkeling, Degustazione di vini',
      type: 'Tipo',
      startTime: 'Ora di inizio', duration: 'Durata', durationHours: 'h', durationMinutes: 'min',
      venueName: 'Nome del luogo', zone: 'Zona / Quartiere',
      bookingUrl: 'URL prenotazione', notes: 'Note',
      notesPlaceholder: 'Solo contanti, prenotare in anticipo...',
      update: 'Aggiorna', addActivity: 'Aggiungi attività', saveAndAddAnother: 'Salva e aggiungine un’altra',
      day: 'Giorno',
      dayBookingHint: 'Viene da una prenotazione — cambiare giorno sposta anche la prenotazione.',
      dayStayHint: 'Una scheda per notte — cambia le date dell\'alloggio in Prenotazioni.',
      fromPlaces: 'Da luoghi salvati', filterPlaces: 'Filtra luoghi…', noMatchPlaces: 'Nessun risultato',
    },
    types: {
      RESTAURANT: 'Ristorante', CAFE: 'Caffè', MONUMENT: 'Monumento', VIEWPOINT: 'Belvedere',
      NEIGHBORHOOD: 'Quartiere', PARK: 'Parco', SHOP: 'Negozio', EXPERIENCE: 'Esperienza',
      TRANSPORT: 'Trasporto', PARKING: 'Parcheggio', BEACH: 'Spiaggia', NATURE: 'Natura', ACCOMMODATION: 'Alloggio', OTHER: 'Altro',
    },
    toast: {
      added: 'Attività aggiunta!', addedWithPlace: 'Attività aggiunta · {{name}} salvato in Luoghi',
      updated: 'Attività aggiornata',
      deleted: 'Attività eliminata', failed: 'Errore nel salvataggio dell\'attività',
      loadFailed: 'Errore nel caricamento dell\'itinerario', removedSuccess: 'Attività rimossa',
      movedToDay: 'Spostata al giorno {{n}}',
      optimizeFailed: "Errore nell'ottimizzazione con l'IA", optimizeNoResult: 'Impossibile ottimizzare il percorso',
      optimizeApplied: 'Percorso ottimizzato applicato', reorderFailed: 'Impossibile salvare il nuovo ordine',
    },
    undo: { action: 'Annulla', undoLabel: 'Annulla (Ctrl+Z)', redoLabel: 'Ripeti (Ctrl+Maiusc+Z)', undone: 'Annullato', failed: 'Impossibile annullare — il programma è stato ricaricato', reordered: 'Ordine modificato', legMode: 'Mezzo di trasporto modificato' },
    empty: {
      noDays: 'Nessun giorno ancora',
      noDaysDesc: 'I giorni vengono generati automaticamente dalle date del viaggio. Per aggiungerne altri, estendi la data di fine nelle impostazioni.',
      clickDay: 'Clicca su un giorno del viaggio per vedere le attività',
      noEvents: 'Nessun evento. Aggiungi giorni e attività prima.',
      noActivities: 'Nessuna attività ancora',
      addStop: 'Aggiungi tappa', planWithAi: 'Pianifica con gIA', fromSaved: 'Dai miei luoghi salvati',
      planPrompt: 'Pianificami il giorno {{n}}: scegli le tappe, mettile in un ordine sensato e dai un orario a ciascuna.',
    },
    dow: { mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Gio', fri: 'Ven', sat: 'Sab', sun: 'Dom' },
    dayUnit_one: 'GIORNO', dayUnit_other: 'GIORNI',
  },
  venues: {
    title: 'Luoghi da visitare',
    categories: {
      RESTAURANT: 'Ristoranti', CAFE: 'Caffè', ATTRACTION: 'Attrazioni',
      VIEWPOINT: 'Belvederi', NEIGHBORHOOD: 'Quartieri', PARK: 'Parchi',
      SHOP: 'Negozi', EXPERIENCE: 'Esperienze', TRANSPORT_HUB: 'Trasporti',
      BEACH: 'Spiagge', NATURE: 'Natura', PARKING: 'Parcheggi', OTHER: 'Altri',
    },
    filter: { all: 'Tutti', toVisit: 'Da visitare', visited: 'Visitati', day: 'Giorno', scheduled: 'Con giorno', unscheduled: 'Senza giorno' },
    noDaySection: 'Senza giorno assegnato',
    progress: '{{visited}} di {{total}} visitati',
    placesCount_one: 'LUOGO', placesCount_other: 'LUOGHI',
    addPlace: 'Aggiungi luogo', editPlace: 'Modifica luogo', addToItinerary: "Aggiungi all'itinerario",
    addToDay: 'Aggiungi al giorno',
    mapView: 'Mappa', maps: 'Maps', book: 'Prenota',
    markVisited: 'Segna come visitato', markUnvisited: 'Rimuovi visitato', visited: 'Visitato',
    viewOnMaps: 'Vedi su Google Maps',
    openNow: 'Aperto ora', closedNow: 'Chiuso ora', fullSchedule: 'Vedi orario completo', closedDay: 'Chiuso',
    hoursDisclaimer: "L'orario potrebbe non essere aggiornato al 100% — verifica con il locale.",
    showDetails: 'Vedi foto e recensioni', showDetailsSource: '· via Google',
    detailsUnavailable: 'Nessuna informazione aggiuntiva per questo posto.',
    deleted: 'Luogo eliminato',
    form: {
      name: 'Nome', category: 'Categoria', address: 'Indirizzo',
      priceInfo: 'Prezzo', bookingUrl: 'URL prenotazione', notes: 'Note',
      searchPlace: 'Cerca un luogo o indirizzo…',
      namePlaceholder: 'es. Da Marietta', pricePlaceholder: 'es. ~20€/persona', notesPlaceholder: 'Solo contanti, prenotare 2 settimane prima…',
      customCategory: 'Tipo di luogo', customCategoryPlaceholder: 'es. Grotta, Cantina, Terme',
      yourCategories: 'Le tue categorie', newCategory: '+ Nuova categoria…',
    },
    bulk: { addToDay: 'Aggiungi a un giorno…', scheduled_one: 'Aggiunto al giorno {{n}}', scheduled_other: '{{count}} luoghi aggiunti al giorno {{n}}' },
    noMatch: 'Nessun luogo corrisponde a questo filtro.',
    day_one: 'Giorno {{days}}', day_other: 'Giorni {{days}}',
    empty: { title: 'Costruisci la tua lista di luoghi', body: 'Salva ogni ristorante, monumento, caffè e punto panoramico. Segnali come visitati mentre esplori e collegati direttamente a Google Maps.', addFirst: 'Aggiungi il primo luogo', askAi: "Chiedi suggerimenti all'IA" },
    delete: {
      title: 'Elimina luogo',
      body: 'Sei sicuro di voler eliminare questo luogo? Questa azione non può essere annullata.',
      confirm: 'Elimina',
      withStops_one: 'È anche una tappa del giorno {{days}} — quella tappa se ne va con lui.',
      withStops_other: 'È anche una tappa dei giorni {{days}} — quelle tappe se ne vanno con lui.',
    },
    toast: {
      loadFailed: 'Impossibile caricare i luoghi',
      deleted: 'Luogo eliminato',
      added: '{{name}} aggiunto ai tuoi luoghi',
      addFailed: 'Impossibile aggiungere il luogo',
      updated: 'Luogo aggiornato',
      saveFailed: 'Impossibile salvare il luogo',
      suggestionAdded_one: '{{count}} nuovo luogo aggiunto',
      suggestionAdded_other: '{{count}} nuovi luoghi aggiunti',
      suggestionFailed: 'Impossibile generare altri suggerimenti',
      suggestionError: 'Errore durante la generazione dei suggerimenti',
    },
  },
  map: {
    routeError: 'Impossibile calcolare il percorso', stopsCount_one: '{{count}} tappa', stopsCount_other: '{{count}} tappe',
    travelMode: { WALKING: 'A piedi', DRIVING: 'Auto', BICYCLING: 'Bici', TRANSIT: 'Trasporti', FERRY: 'Traghetto', FLIGHT: 'Volo', TRANSFER: 'Trasferimento', ferryLeg: '{{duration}} in traghetto', unavailable: 'Non disponibile per questa tratta', fallbackToast_one: 'Questo mezzo non ha un percorso qui — sostituito con uno che ce l’ha', fallbackToast_other: 'Nessun percorso con questo mezzo su {{count}} tratte — sostituite con uno che ce l’ha' },
    allPlaces: 'Tutti i luoghi',
    dayLabel: 'Giorno {{n}}',
    showOnlyCategory: 'Mostra solo {{label}}',
    destinationChip: { showWholeTrip: 'Vedi tutto il viaggio', showOnly: 'Vedi solo {{name}}' },
    removeCategoryFilter: 'Rimuovi il filtro {{label}}',
    showAllCategories: 'Mostra tutte le categorie',
    collapsePanel: 'Comprimi pannello', expandPanel: 'Espandi pannello',
    quota: { title: 'Limite mensile di mappe raggiunto', body: 'Luoghi, itinerari e ricerche sono in pausa finché il limite non si rinnova.', bodyWithDate: 'Luoghi, itinerari e ricerche sono in pausa finché il limite non si rinnova il {{date}}.', hint: 'Il resto del viaggio continua a funzionare normalmente.' },
    unavailable: { title: 'Impossibile caricare la mappa', body: 'Google Maps non ha risposto. Controlla la connessione e riprova tra un momento.' },
    dayFilter: 'Giorno',
    showAll: 'Mostra tutto', hideAll: 'Nascondi tutto',
    showAllDays: "Mostra tutti i giorni",
    optionalStops: 'Opzionali',
    optionalStopsHint: 'Nasconde le tappe opzionali. Il percorso disegnato ci passa ancora: il tratto attenuato è quello che risparmieresti saltandole.',
    dayNotCalculated: "Impossibile calcolare il percorso di questo giorno",
    scrollLeft: 'Scorri a sinistra', scrollRight: 'Scorri a destra',
    searchPlaces: 'Cerca luoghi…',
    legFromTo: 'Tragitto da {{from}} a {{to}}',
    calculating: 'Calcolo in corso…',
    routes: 'Percorsi',
    daysCount_one: '{{count}} giorno', daysCount_other: '{{count}} giorni',
    noDaysSelected: 'Nessun giorno selezionato',
    savedPlaces: 'Luoghi salvati', savedPlacesHint: 'Mostra i luoghi salvati che non sono in nessun percorso',
    showOnMap: 'Vedi {{name}} sulla mappa',
    places: 'Luoghi', fullRoute: 'Percorso completo',
    calculatingRoutes: 'Calcolo percorsi…',
    optimizing: 'Ottimizzazione…',
    optimizeWith: 'Ottimizza con',
    optimize: 'Ottimizza',
    openInMaps: 'Apri in Maps',
    recenter: 'Ricentra la mappa',
    savePlaceModal: 'Salva luogo',
    addToItineraryModal: "Aggiungi all'itinerario",
    aiOptimizePrompt: "Ottimizza l'ordine delle tappe di oggi per ridurre al minimo gli spostamenti.",
    aiOptimizeHintPrefix: "Indicazioni dell'utente (prioritarie sui criteri generici)",
    aiHint: {
      title: "Indicazioni per l'IA",
      subtitle: 'Opzionale. Indica orari, pasti o preferenze specifiche.',
      placeholder: 'Es. La Sagrada Família al mattino, cena di tapas verso le 21…',
    },
    center: 'Centra', save: 'Salva',
    aiProposalTitle: 'Suggerimento percorso IA', proposedOrder: 'Ordine proposto',
    filter: 'Filtra',
    locatingPlaces: 'Localizzazione dei luoghi…', locationsToFind: 'luoghi da trovare',
    noDaysYet: 'Nessun giorno nell\'itinerario', addDaysFirst: 'Aggiungi giorni nella scheda Itinerario.',
    loadError: 'Errore nel caricamento di Google Maps. Verifica la chiave API.',
    collapseStops: 'Comprimi fermate', expandStops: 'Espandi fermate', tapToSeeStops: 'Tocca per vedere le fermate',
  },
  bookings: {
    expenses: { paid: 'Pagato per questa prenotazione', add: 'Aggiungi spesa' },
    types: { TRANSPORT: 'Trasporto', EVENT: 'Evento', ACTIVITY: 'Attività', RESTAURANT: 'Ristorante', OTHER: 'Altro' },
    title: 'Prenotazioni e biglietti', subtitle: 'Voli, hotel, trasporti e biglietti',
    sections: { flights: 'Voli', hotels: 'Hotel e alloggi', transport: 'Trasporti', events: 'Eventi e biglietti' },
    form: {
      direction: 'Direzione', outbound: '→ Andata', return: '← Ritorno',
      from: 'Da (IATA)', to: 'A (IATA)', departure: 'Partenza', arrival: 'Arrivo',
      flightNumber: 'Numero di volo', airline: 'Compagnia aerea',
      bookingRef: 'Riferimento prenotazione', notes: 'Note',
      hotelName: 'Nome dell\'hotel', address: 'Indirizzo', checkIn: 'Check-in', checkOut: 'Check-out',
      currency: 'Valuta', bookingUrl: 'URL prenotazione',
      category: 'Categoria', title: 'Titolo', provider: 'Fornitore / Azienda',
      date: 'Data', startTime: 'Ora di inizio', endTime: 'Ora di fine',
      startDate: 'Data di inizio', endDate: 'Data di fine',
      endDateHint: 'Solo se dura più giorni',
      endDateBeforeStart: 'La data di fine è precedente a quella di inizio',
      venue: 'Luogo / Venue', price: 'Prezzo', confirmed: 'Confermato',
      documents: 'Documenti (PDF, immagini, email)',
      saveChanges: 'Salva modifiche', addFlight: 'Aggiungi volo', addHotel: 'Aggiungi hotel', addBooking: 'Aggiungi prenotazione',
      legs: 'Tratte', addLeg: 'Aggiungi tratta', passengers: 'Passeggeri',
      searchPlace: 'Cerca un luogo o indirizzo…',
      extractWithAi: 'Compila con IA', extracting: 'Lettura documento…', addWithAi: 'Aggiungi con IA',
      addWithAiTitle: 'Aggiungi con IA',
      addWithAiExplanation: "Carica un biglietto, una carta d'imbarco o una conferma di prenotazione (PDF, foto o la email stessa salvata come .eml) e la leggiamo per te, allegati inclusi: date, orari, numero di volo, riferimenti di prenotazione e altro vengono compilati automaticamente. Potrai comunque rivedere tutto prima di salvare.",
      addWithAiDropTitle: 'Trascina qui il tuo file', addWithAiDropSubtitle: 'o clicca per cercarlo — PDF, immagine o email (.eml)',
      unreviewedTitle_one: 'Resta 1 volo da controllare', unreviewedTitle_other: 'Restano {{count}} voli da controllare',
      unreviewedBody_one: 'È stato letto dal documento ma non è ancora salvato. Se chiudi ora, non verrà aggiunto.',
      unreviewedBody_other: 'Sono stati letti dal documento ma non sono ancora salvati. Se chiudi ora, non verranno aggiunti.',
      unreviewedDiscard: 'Scarta', unreviewedKeep: 'Continua a controllare',
      stepIndicator: 'Passaggio {{current}} di {{total}}', saveAndContinue: 'Salva e continua',
      legNumber: 'Tratta {{n}}', removeLeg: 'Elimina tratta', arrivalBeforeDeparture: 'arrivo ≤ partenza',
      hotelNamePlaceholder: 'Il Grand Hotel',
      bookingTitlePlaceholder: 'es. Renfe AVE Madrid–Barcellona',
      venuePlaceholder: 'Bernabéu, Teatro Real…',
    },
    reminder: {
      startsIn: 'Inizia tra {{delay}}', endsIn: 'Finisce tra {{delay}}',
      endTitle: 'Fine · {{title}}',
      label: 'Promemoria prima dell\'evento', minutes: 'minuti', hours: 'ore',
      warnNoTime: 'Imposta un orario di inizio per attivare il promemoria',
    },
    docs: {
      title: 'Documenti', upload: 'Carica file',
      dropHere: 'Trascina un PDF, immagine o email (.eml) qui, o clicca per caricare',
      attachFile: 'Allega biglietto, PDF, screenshot o email', addMore: 'Aggiungi altri file',
      deleteTitle: 'Eliminare il documento?', deleteConfirm: 'Eliminare "{{name}}"? Questa azione non può essere annullata.',
    },
    deleteItem: {
      flightTitle: 'Eliminare il volo?', hotelTitle: 'Eliminare l\'hotel?', bookingTitle: 'Eliminare la prenotazione?',
    },
    empty: {
      noFlights: 'Nessun volo aggiunto', noHotels: 'Nessun hotel aggiunto',
      noTransport: 'Aggiungi treni, autobus, traghetti o auto a noleggio',
      noEvents: 'Aggiungi concerti, teatro, sport, tour, ristoranti…',
      addOne: 'Aggiungine',
    },
    notifications: {
      blocked: 'Le notifiche sono bloccate. Abilitale nelle impostazioni del browser per ricevere promemoria.',
      prompt: 'Abilita le notifiche del browser per ricevere promemoria prima delle tue prenotazioni.',
      enableBtn: 'Abilita',
    },
    status: { outbound: 'Andata', return: 'Ritorno', confirmed: 'Confermato', pending: 'In attesa' },
    modal: {
      editFlight: 'Modifica volo', addFlight: 'Aggiungi volo',
      editHotel: 'Modifica hotel', addHotel: 'Aggiungi hotel',
      editBooking: 'Modifica prenotazione', addBooking: 'Aggiungi prenotazione',
    },
    toast: {
      loadFailed: 'Errore nel caricamento delle prenotazioni', saveFailed: 'Errore nel salvataggio',
      flightDeleted: 'Volo eliminato', hotelDeleted: 'Hotel eliminato', bookingDeleted: 'Prenotazione eliminata',
      flightAdded: 'Volo aggiunto', flightUpdated: 'Volo aggiornato',
      hotelAdded: 'Hotel aggiunto', hotelUpdated: 'Hotel aggiornato',
      bookingAdded: 'Prenotazione aggiunta', bookingUpdated: 'Prenotazione aggiornata',
      fileDeleted: 'File eliminato', uploadFailed: 'Caricamento fallito',
      uploadFileFailed: 'Caricamento di {{name}} non riuscito',
      filesUploaded_one: '{{count}} file caricato', filesUploaded_other: '{{count}} file caricati',
      extractSuccess: 'Dati compilati — controlla prima di salvare', extractFailed: 'Impossibile leggere il documento',
      extractNoMatch: 'Impossibile abbinare: {{names}}. Aggiungili manualmente.',
    },
    yourTickets: 'I tuoi biglietti',
    bookingsCount_one: 'PRENOTAZIONE', bookingsCount_other: 'PRENOTAZIONI',
    durationDays_one: '{{count}} giorno', durationDays_other: '{{count}} giorni',
    view: { sections: 'Sezioni', timeline: 'Cronologia' },
    timeline: { dayLabel: 'Giorno {{n}}', noTickets: 'Nessun biglietto', ongoingDay: 'giorno {{n}}/{{total}}', ongoingEnd: 'ultimo giorno' },
    ticket: {
      from: 'Partenza', to: 'Arrivo', direct: 'Diretto',
      layover_one: '{{count}} scalo', layover_other: '{{count}} scali',
      layoverAt: 'Scalo a {{airport}}',
    },
  },
  expenses: {
    reservationGroups: { FLIGHT: 'Voli', HOTEL: 'Alloggi', BOOKING: 'Altre prenotazioni' },
    travellersCount_one: '{{count}} VIAGGIATORE', travellersCount_other: '{{count}} VIAGGIATORI',
    title: 'Spese',
    ledger: 'Il registro',
    redistribute: {
      title: 'Nuovi membri nel viaggio',
      desc_one: '{{names}} si è unito dopo la registrazione di alcune spese. Dividere anche con lui/lei la {{count}} spesa condivisa precedente?',
      desc_other: '{{names}} si è unito dopo la registrazione di alcune spese. Dividere anche con lui/lei le {{count}} spese condivise precedenti?',
      apply: 'Dividi con loro',
      dismiss: 'Non ora',
      done_one: 'Ridistribuita {{count}} spesa',
      done_other: 'Ridistribuite {{count}} spese',
      failed: 'Impossibile ridistribuire le spese',
    },
    stats: { totalSpent: 'Totale speso', expenses: 'Spese', biggest: 'Il maggiore' },
    subtitle_one: '{{count}} voce', subtitle_other: '{{count}} voci',
    addExpense: 'Aggiungi spesa', editExpense: 'Modifica spesa',
    delete: { link: 'Elimina spesa', title: 'Eliminare questa spesa?' },
    expenseCount_one: '{{count}} spesa', expenseCount_other: '{{count}} spese',
    splits_one: '{{count}} divisione', splits_other: '{{count}} divisioni',
    chart: { totalSpent: 'Totale speso', total: 'totale' },
    groupBy: { all: 'Tutti', byCategory: 'Per categoria' },
    scan: {
      button: 'Scansiona uno scontrino',
      aiButton: 'Scansiona con l’IA',
      scanning: 'Lettura…',
      success: 'Scontrino letto — controlla i dati',
      failed: 'Impossibile leggere il file. Inseriscilo a mano.',
      title: 'Scansiona spese con l’IA',
      explanation: 'Carica uno scontrino, o una schermata della tua banca o del tuo wallet con diverse transazioni — ogni spesa trovata torna qui per la revisione.',
      dropTitle: 'Trascina qui uno scontrino o una schermata',
      dropSubtitle: 'Immagini o PDF · fino a {{count}} file',
      reviewHint_one: '{{count}} spesa rilevata. Deseleziona ciò che non vuoi e tocca una riga per modificarla.',
      reviewHint_other: '{{count}} spese rilevate. Deseleziona ciò che non vuoi e tocca una riga per modificarla.',
      noDescription: 'Senza descrizione',
      noRate: 'senza cambio',
      rateFailed: 'Impossibile ottenere il cambio di oggi per {{currencies}}.',
      fixRow: 'Completa prima la spesa evidenziata.',
      include: 'Includi questa spesa',
      exclude: 'Escludi questa spesa',
      selectedTotal_one: '{{count}} selezionata',
      selectedTotal_other: '{{count}} selezionate',
      addSelected_one: 'Aggiungi {{count}} spesa',
      addSelected_other: 'Aggiungi {{count}} spese',
      savedCount_one: '{{count}} spesa aggiunta',
      savedCount_other: '{{count}} spese aggiunte',
      savedFailed_one: '{{count}} spesa non è stata salvata',
      savedFailed_other: '{{count}} spese non sono state salvate',
    },
    form: {
      reservation: 'Prenotazione collegata', reservationNone: '— Nessuna —',
      description: 'Descrizione', descriptionPlaceholder: 'es. Prenotazione hotel',
      category: 'Categoria', payment: 'Pagamento', amount: 'Importo',
      currency: 'Valuta', date: 'Data', status: 'Stato',
      splitBetween: 'Dividere tra', perPerson: '{{currency}} {{amount}} / persona',
      notes: 'Note', saveChanges: 'Salva modifiche', addExpense: 'Aggiungi spesa',
      paidBy: 'Pagato da', you: 'Tu', noCurrencies: 'Nessun risultato',
      conversion: {
        title: 'Converti in {{currency}}',
        loading: 'Caricamento…', refresh: 'Aggiorna tasso',
        manual: 'Tasso non disponibile — inseriscilo manualmente.',
        asOf: 'Tasso del {{date}}',
      },
    },
    categories: {
      ACCOMMODATION: 'Alloggio', FLIGHTS: 'Voli', FOOD: 'Cibo',
      ACTIVITIES: 'Attività', TRANSPORT: 'Trasporti',
      FUEL: 'Carburante', PARKING: 'Parcheggio', CASH: 'Contanti', OTHER: 'Altro',
    },
    payment: { CARD: 'Carta', CASH: 'Contanti', TRANSFER: 'Bonifico' },
    status: { PAID: 'Pagato', PENDING: 'In attesa' },
    settlement: {
      title: 'Piano di liquidazione', even: 'Tutti in pari',
      allDone: 'Tutti i bonifici confermati', pending: '{{pending}} di {{total}} in attesa',
      allEven: 'Tutti in pari — nessun bonifico necessario!',
      confirmed: 'Confermato', settle: 'Salda', undo: 'Annulla',
      onlySelf: 'Aggiungi più partecipanti al viaggio per dividere le spese e vedere chi deve cosa.',
      payIn: 'Paga in', markSettled: 'Segna saldata',
      rateUnavailable: 'Tasso di cambio non disponibile',
      paidAs: 'Pagato come {{amount}} {{currency}}',
    },
    budget: {
      title: 'Budget', manage: 'Budget', set: 'Imposta budget', edit: 'Modifica',
      empty: 'Nessun budget impostato',
      emptyDesc: 'Imposta limiti di spesa per totale, giorno, categoria o persona e ricevi un avviso prima di sforare.',
      total: 'Totale viaggio', daily: 'Al giorno',
      categorySection: 'Per categoria', personSection: 'Per persona',
      tripSection: 'Limiti dell’intero viaggio',
      tripSectionHint: 'Questi tetti valgono per tutto il viaggio, non al giorno.',
      dailySection: 'Tetto giornaliero',
      dailyHint: 'Un tetto per ogni singolo giorno — ti avvisiamo quando un giorno si avvicina o lo supera.',
      noLimit: 'Nessun limite',
      leftAmount: 'Restano {{amount}}', overAmount: 'Superato di {{amount}}', atLimit: 'Limite raggiunto',
      worstDay: 'Giorno peggiore: {{amount}}',
      daysOver_one: '{{count}} giorno oltre il limite', daysOver_other: '{{count}} giorni oltre il limite',
      save: 'Salva budget', saved: 'Budget salvati', failed: 'Impossibile salvare i budget',
      alertsTitle: 'Avvisi di budget',
      overToast: 'Attenzione — hai appena superato il budget {{label}}',
      warnToast: 'Ti stai avvicinando al budget {{label}}',
    },
    debts: {
      title: 'Debiti saldati', recalculate: 'Ricalcola',
      showSettled: 'Mostra saldati ({{count}})', hideSettled: 'Nascondi saldati ({{count}})',
    },
    empty: {
      title: 'Tieni traccia delle spese condivise',
      desc: 'Registra ogni spesa e dividila tra i viaggiatori. L\'app calcola chi deve cosa e ti permette di saldare i debiti con un tap.',
      addFirst: 'Aggiungi prima spesa',
    },
    toast: {
      settled: 'Debito saldato!', recalculated: 'Debiti ricalcolati', deleted: 'Spesa eliminata',
      updated: 'Spesa aggiornata!', added: 'Spesa aggiunta!',
      failedUpdate: 'Errore nell\'aggiornamento della spesa', failedAdd: 'Errore nell\'aggiunta della spesa',
      selectParticipant: 'Seleziona almeno un partecipante', loadFailed: 'Errore nel caricamento delle spese',
      rateRequired: 'Inserisci un tasso di cambio valido',
    },
    filters: {
      button: 'Filtra', clear: 'Pulisci', day: 'Giorno', category: 'Categoria',
      paidBy: 'Pagato da', remove: 'Togli {{filter}}',
      showing_one: '{{count}} spesa', showing_other: '{{count}} spese',
    },
    table: {
      all: 'TUTTE', noFilter: 'Nessuna spesa corrisponde al filtro',
      date: 'Data', item: 'Voce', category: 'Categoria', paidBy: 'Pagato da', split: 'Divisione', amount: 'Importo',
      editRow: 'Modifica {{description}}',
      linkedReservation: 'Collegato a una prenotazione',
    },
    spendingByPerson: 'Spesa per persona',
    byPerson: {
      traveller: 'Viaggiatore', paid: 'Pagato', share: 'La sua parte', balance: 'Saldo',
      formerTraveller: 'Viaggiatore uscito',
      hint: 'Pagato è quello che ha anticipato. La sua parte è quanto gli spetta secondo la divisione.',
    },
    spendingByDay: 'Spesa per giorno',
    byCategory: 'Per categoria',
    whoOwesWhom: 'Chi deve a chi',
    settledCount: 'Saldato · {{count}}',
    baseCurrency: {
      title: 'Valuta base',
      desc: 'I saldi e il budget sono mostrati in questa valuta; le spese in altre valute vengono convertite in essa. Puoi cambiarla solo prima di aggiungere una spesa.',
      edit: 'Cambia valuta base',
      saving: 'Salvataggio…',
      saved: 'Valuta base aggiornata',
      failed: 'Impossibile aggiornare la valuta base',
    },
  },
  info: {
    deleteTip: 'Elimina consiglio',
    tipsSectionTitle: 'Tips',
    title: 'Consigli di viaggio', subtitle: 'Consigli in base alla tua destinazione',
    tips: 'Consigli di viaggio',
    heading: 'Consigli di viaggio',
    quickSuggestions: 'Suggerimenti rapidi',
    acceptAndAdd: 'Accetta e aggiungi',
    discard: 'Scarta',
    saving: 'Salvataggio…',
    tipsProposalLabel: 'Proposta · {{count}} consigli',
    tipsAdded_one: '{{count}} consiglio aggiunto',
    tipsAdded_other: '{{count}} consigli aggiunti',
    loadFailed: 'Impossibile caricare i consigli',
    tipsGenerateFailed: 'Impossibile generare i consigli',
    tipsSaveFailed: 'Impossibile salvare i consigli',
    tipsAiDefault: 'Dammi i consigli più utili per questa destinazione.',
    tipsAiPlaceholder: 'Es: consigli per chi va per la prima volta…',
    tipsAiMorePlaceholder: 'Chiedi altri consigli o modifiche…',
    addTipCategoryPlaceholder: 'Categoria',
    addTipContentPlaceholder: 'Contenuto del consiglio…',
    addTipBtn: 'Aggiungi consiglio',
    addTipLabel: 'Aggiungi un consiglio',
    suggestedCategories: 'Categorie suggerite',
    tipCategories: ['Trasporti', 'Visti e ingresso', 'Denaro e bancomat', 'Sicurezza', 'Lingua', 'Usanze locali', 'Scheda SIM', 'Meteo'] as string[],
    tipsPrompts: ['Consigli essenziali per questa destinazione', 'Trasporto pubblico e taxi', 'Soldi, mance e sportelli ATM', 'Sicurezza e truffe comuni', 'Frasi utili in lingua locale', 'Usanze locali'] as string[],
  },
  meals: {
    savedFlash: "Salvato",
    title: 'Pasti',
    subtitle: 'Cosa si mangia ogni giorno, e cosa serve comprare per farlo.',
    slot: {
      BREAKFAST: 'Colazione', LUNCH: 'Pranzo', SNACK: 'Merenda',
      DINNER: 'Cena', OTHER: 'Altro',
    },
    addTo: 'Aggiungi {{slot}}',
    addAtPlace: 'Al ristorante',
    pickSaved: 'Scegline uno salvato',
    placeholder: 'Pasta al salmone, cena da Dill…',
    notesPlaceholder: 'Note (facoltativo)',
    linkVenue: 'Collega un luogo',
    editMeal: 'Modifica pasto',
    noVenue: 'Nessun luogo',
    searchPlace: 'Cerca un ristorante o un caffè…',
    venueHint: 'Scegli un ristorante o un caffè salvato, oppure cercalo: verrà salvato in Luoghi.',
    emptyDay: 'Niente in programma',
    ingredients: {
      title: 'Ingredienti', add: 'Aggiungi ingrediente',
      namePlaceholder: 'Salmone, pasta…', amountPlaceholder: 'Qtà', amountLabel: 'Quantità',
      unit: 'Unità', remove: 'Rimuovi {{name}}',
      unitMismatch: 'Questo prodotto è già contato in un\'altra unità',
      editAmount: 'Cambia quantità di {{name}}',
    },
    units: { u: 'pz', g: 'g', kg: 'kg', ml: 'ml', l: 'l' },
    pantry: {
      title: 'Dispensa',
      hint: 'Quanto comprato, meno quello che hanno mangiato i pasti dei giorni passati.',
      left: 'restano {{amount}}', missing: 'mancano {{amount}}',
      planned: 'piano {{amount}}', bought: 'comprato {{amount}}', pending: '{{amount}} in lista',
      addMissingFor: 'Aggiungi alla lista quello che manca di {{name}}',
      added: '{{name}} aggiunto alla lista',
      addShort: 'Aggiungi', onList: 'In lista',
    },
    grocery: {
      setAmount: 'quantità',
      amountLabel: 'Quantità da comprare', unitLabel: 'Unità di acquisto',
      title: 'Lista della spesa',
      add: 'Aggiungi alla lista',
      placeholder: 'Salmone fresco',
      forMeal: 'per {{title}}',
      empty: 'Non c\'è ancora niente da comprare.',
      emptyHint: 'Annota cosa serve per i pasti e spuntalo al negozio.',
      bought_one: '{{count}} nel carrello',
      bought_other: '{{count}} nel carrello',
      clearBought: 'Svuota ciò che è comprato',
      cleared_one: '{{count}} articolo rimosso',
      cleared_other: '{{count}} articoli rimossi',
      collapse: 'Nascondi la lista della spesa',
      expand: 'Mostra la lista della spesa',
    },
    toast: {
      created: 'Pasto aggiunto',
      deleted: 'Pasto rimosso',
      saveFailed: 'Impossibile salvare il pasto',
      deleteFailed: 'Impossibile rimuovere il pasto',
      groceryFailed: 'Impossibile salvare la lista della spesa',
      stopFailed: "Impossibile aggiornare la tappa dell'itinerario",
    },
    // ADR-0024: a meal linked to a stop of its day.
    stop: {
      pick: "Collega a una tappa…",
      create: "Aggiungi all'itinerario",
      timePlaceholder: "Ora",
      hint: "Collegato a una tappa, il titolo e il luogo restano uguali in entrambi.",
      linked: "Nell'itinerario",
      linkedAt: "Nell'itinerario alle {{time}}",
      otherDay: "La sua tappa è al giorno {{day}}",
      unlink: "Scollega",
      badge: "Piano",
    },
    deleteLinked: {
      title: "Questo pasto è una tappa dell'itinerario",
      body: "Eliminare anche la tappa?",
      only: "Solo il pasto",
    },
  },
  packing: {
    outfits: {
      heading: "Vestiti per giorno",
      hint: "Pianifica cosa indosserai ogni giorno con i vestiti della tua valigia. Dividi la giornata in momenti solo se ti aiuta (spiaggia, cena…).",
      piecePlaceholder: "Scrivi o scegli un capo…",
      addNew: "Aggiungi «{{text}}» alla tua valigia",
      addNewTo: "Aggiungi «{{text}}» a {{section}}",
      sectionEmpty: "Non resta niente in questa sezione — scrivi un capo per aggiungerlo.",
      fromSection: "Dalla sezione",
      suitcaseEmpty: "Ancora nessun vestito in valigia — scrivi un capo per aggiungerlo.",
      addPiece: "Aggiungi vestiti",
      addGroup: "Dividi per momenti della giornata",
      groupPrompt: "Per quale momento?",
      groupPresets: ["Spiaggia", "Cena", "Sport", "Escursione", "Serata"],
      dragHint: "Trascinalo in un altro momento",
      allDay: "Tutto il giorno",
      groupPlaceholder: "Un altro momento…",
      groupName: "Nome del momento",
      renameGroup: "Rinomina il momento",
      deleteGroup: "Togli il momento",
      deleteGroupHint: "I suoi vestiti tornano a «Tutto il giorno»",
      removePiece: "Togli {{text}} da questo giorno",
      packed: "In valigia",
      notPacked: "Non ancora in valigia",
      pieceCount_one: "{{count}} capo",
      pieceCount_other: "{{count}} capi",
      emptyDay: "Niente di previsto",
      loadFailed: "Impossibile caricare i vestiti per giorno",
      addFailed: "Impossibile aggiungere il capo",
    },
    addSuggested_one: 'Aggiungi {{count}} sezione',
    addSuggested_other: 'Aggiungi {{count}} sezioni',
    addSectionFailed: 'Non è stato possibile aggiungere la sezione',
    scope: {
      mine: 'La mia', common: 'Comune', someone: 'Qualcuno',
    },
    sharing: {
      on: 'La vede il gruppo', off: 'Solo io',
      onHint: 'Gli altri vedono la tua valigia. Tocca per tenerla per te.',
      offHint: 'Solo tu vedi la tua valigia. Tocca per condividerla con il gruppo.',
      nowShared: 'La tua valigia ora è visibile al gruppo',
      nowPrivate: 'La tua valigia ora è privata',
      failed: 'Non è stato possibile cambiare chi vede la tua valigia',
    },
    copy: {
      button: 'Copia da un altro viaggio',
      title: 'Copia sezioni della valigia',
      pickTrip: 'Da quale viaggio vuoi copiare?',
      noTrips: 'Non hai ancora altri viaggi da cui copiare.',
      backToTrips: 'Scegli un altro viaggio',
      pickSections: 'Sezioni da copiare',
      items_one: '{{count}} oggetto',
      items_other: '{{count}} oggetti',
      selectAll: 'Seleziona tutto',
      clearAll: 'Deseleziona',
      nothingToCopy: 'Quel viaggio non ha ancora sezioni della valigia con oggetti.',
      mergeHint: 'Le sezioni con lo stesso nome vengono unite e ciò che hai già non viene duplicato.',
      confirm_one: 'Copia {{count}} sezione',
      confirm_other: 'Copia {{count}} sezioni',
      copying: 'Copia in corso…',
      done_one: '{{count}} oggetto aggiunto',
      done_other: '{{count}} oggetti aggiunti',
      nothingNew: 'Avevi già tutto nella tua lista',
      loadFailed: 'Impossibile caricare la valigia di quel viaggio',
      failed: 'Impossibile copiare le sezioni',
    },
    assignee: { label: 'Chi lo porta', nobody: 'Ancora nessuno' },
    readOnlyHint: 'La valigia di un’altra persona: puoi vederla, ma non modificarla.',
    emptySection: 'Qui non c’è ancora niente',
    completedProgress: '{{done}}/{{total}} completato · {{pct}}%',
    title: 'Valigia', subtitle: 'La tua checklist bagagli',
    checklists: 'Checklist pre-viaggio',
    heading: 'Valigia',
    quickSuggestions: 'Suggerimenti rapidi',
    acceptAndAdd: 'Accetta e aggiungi',
    discard: 'Scarta',
    saving: 'Salvataggio…',
    packingProposalLabel: 'Proposta · {{sections}} sezioni · {{items}} elementi',
    sectionsAdded_one: '{{count}} sezione aggiunta alla tua checklist',
    sectionsAdded_other: '{{count}} sezioni aggiunte alla tua checklist',
    sectionRemoved: 'Sezione rimossa',
    loadFailed: 'Impossibile caricare la valigia',
    packingGenerateFailed: 'Impossibile generare la lista bagagli',
    packingGenerateSaveFailed: 'Impossibile salvare la lista bagagli',
    packingAiDefault: 'Genera una lista bagagli completa e personalizzata.',
    packingAiPlaceholder: 'Es: Per donna, viaggio di 5 giorni in estate…',
    packingAiMorePlaceholder: 'Chiedi altre sezioni o modifiche…',
    suggestedSections: 'Sezioni suggerite',
    newSectionPlaceholder: 'Nuova sezione (es: Documenti, Prenotazioni…)',
    addSection: 'Sezione',
    addSectionLabel: 'Aggiungi una sezione',
    addItemPlaceholder: 'Aggiungi elemento…',
    addItemBtn: 'Aggiungi',
    done: 'Fatto ✓',
    packingPrompts: ['Per uomo', 'Per donna', 'Famiglia con bambini', 'Viaggio di lavoro', 'Zaino in spalla', 'Spiaggia / estate', 'Montagna / trekking'] as string[],
    defaultSectionNames: ['Documenti', 'Abbigliamento', 'Beauty case', 'Elettronica', 'Farmaci', 'Prenotazioni', 'Soldi'] as string[],
    sectionAiButton: 'Genera elementi con IA',
    sectionAiPlaceholder: 'Facoltativo: quanti giorni, clima, attività previste…',
    sectionAiGenerate: 'Genera',
    sectionAiPrompt: 'Genera SOLO nuovi elementi da aggiungere alla sezione della lista bagagli "{{title}}" per questo viaggio. Contesto aggiuntivo dell\'utente: {{info}}. Non ripetere elementi già presenti nella lista: {{existing}}. Restituisci un\'unica sezione chiamata esattamente "{{title}}" con solo i nuovi elementi.',
    sectionAiNoExtraInfo: 'nessuno specificato',
    sectionAiNoExistingItems: 'nessuno ancora',
    sectionAiAdded_one: 'Aggiunto {{count}} elemento a "{{title}}"',
    sectionAiAdded_other: 'Aggiunti {{count}} elementi a "{{title}}"',
    sectionAiEmpty: "L'IA non ha suggerito nuovi elementi per questa sezione",
    sectionAiFailed: 'Impossibile generare gli elementi — riprova',
    dragHandle: 'Trascina per riordinare',
    reorderFailed: 'Impossibile salvare il nuovo ordine',
    deleteSection: 'Elimina sezione',
    deleteItem: 'Elimina elemento',
    editItem: 'Tocca per modificare',
    renameItemFailed: 'Impossibile rinominare l\'elemento',
    checkItem: 'Segna come preparato',
    uncheckItem: 'Segna come non preparato',
  },
  shared: {
    viewOnly: 'Viaggio condiviso (sola lettura)',
    noDiary: 'Ancora niente di scritto nel diario.',
    follow: { title: 'Segui questo viaggio', hintAccount: 'Ti avviseremo nell’app quando il gruppo scrive nel diario.', hintEmail: 'Ricevi un’e-mail quando il gruppo scrive nel diario.', follow: 'Segui', following: 'Stai seguendo', followed: 'Segui questo viaggio', unfollowed: 'Non segui più questo viaggio', error: 'Qualcosa è andato storto. Riprova.', emailPlaceholder: 'La tua e-mail', subscribe: 'Avvisami', checkInbox: 'Controlla la posta per confermare.', confirmed: 'Fatto! Ti scriveremo quando ci sarà qualcosa di nuovo.', unsubscribed: 'Non riceverai più e-mail su questo viaggio.', linkExpired: 'Questo link non funziona più.' },
    notFoundTitle: 'Viaggio non trovato',
    notFoundDesc: 'Questo link non è valido o il proprietario ha disabilitato la condivisione.',
    nights_one: '{{count}} notte', nights_other: '{{count}} notti',
    traveller_one: '{{count}} viaggiatore', traveller_other: '{{count}} viaggiatori',
    sections: {
      diary: 'Diario',
      flights: 'Voli', accommodation: 'Alloggio', itinerary: 'Itinerario', about: 'Informazioni sul viaggio',
      places: 'Luoghi', map: 'Mappa', travel: 'Viaggio',
      tips: 'Consigli', photos: 'Foto', meals: 'Pasti', bookings: 'Prenotazioni',
    },
    footer: 'Condiviso con Gromly · Sola lettura',
    outbound: 'Andata', return: 'Ritorno', noActivities: 'Nessuna attività pianificata',
    optional: 'Facoltativo',
    noPlaces: 'Nessun luogo salvato.', noTips: 'Ancora nessun consiglio.', noPhotos: 'Ancora nessuna foto.', noBookings: 'Ancora nessuna prenotazione.',
    openInMaps: 'Apri in Google Maps',
    map: {
      allPlaces: 'Tutti i luoghi', dayByDay: 'Giorno per giorno', dayLabel: 'Giorno {{n}}',
      unavailable: 'Mappa non disponibile', noRouteYet: 'Il percorso di questo giorno non è ancora stato calcolato.',
    },
  },
  account: {
    storage: { title: "Spazio", photos: "Foto", used: "{{used}} di {{quota}}", full: "Il tuo spazio per le foto è pieno. Elimina qualche foto per caricarne di nuove." },
    avatar: { change: "Cambia foto", add: "Aggiungi foto", remove: "Rimuovi foto", cropTitle: "Inquadra la tua foto", zoom: "Zoom", save: "Salva foto", saved: "Foto del profilo aggiornata", removed: "Foto del profilo rimossa", failed: "Impossibile aggiornare la tua foto", unsupported: "Questo file non è una foto utilizzabile" },
    birthDate: "Data di nascita", birthDateHint: "La vedi solo tu. I tuoi viaggi vedono solo la tua età, per segnalarti tariffe e vantaggi in base all'età.", birthDateSaved: "Data di nascita salvata", birthDateSaveFailed: "Impossibile salvare la tua data di nascita",
    nationality: "Nazionalità", nationalitySaveFailed: "Impossibile aggiornare la nazionalità",
    title: 'Account',
    subtitle: 'Gestisci il tuo profilo e le preferenze',
    profile: 'Profilo',
    memberSince: 'Membro dal',
    credits: 'Crediti',
    tripCredits: 'Crediti viaggio',
    aiCredits: 'Crediti IA',
    plan: { title: "Piano", gift: "Regalo di Gromly", free: "Gratuito", proUntil: "PRO fino al {{date}}", manage: "Gestisci abbonamento", inStore: "Gestiscilo su {{store}}", upgrade: "Passa a PRO", restore: "Ripristina acquisti", restored: "Acquisti ripristinati", nothing: "Nessun acquisto da ripristinare" },
    security: 'Sicurezza',
    changePassword: {
      title: 'Cambia password',
      rowHint: 'Aggiorna la password con cui accedi',
      setTitle: 'Imposta una password',
      setHint: 'Il tuo account non ha ancora una password',
      setLinkSent: 'Ti abbiamo mandato un link per impostare una password.',
      setLinkFailed: 'Non siamo riusciti a inviare il link. Riprova tra qualche minuto.',
      current: 'Password attuale',
      new: 'Nuova password',
      confirm: 'Ripeti la nuova password',
      signsOutOthers: 'Qui resti connesso, ma su tutti gli altri dispositivi la sessione verrà chiusa.',
      submit: 'Cambia password',
      success: 'Password cambiata.',
      wrongCurrent: 'Questa non è la tua password attuale.',
      unchanged: 'La nuova password è uguale a quella attuale.',
      googleAccount: "Questo account accede con Google. Usa il link ricevuto via email per impostare una password.",
      failed: 'Non siamo riusciti a cambiare la password. Riprova.',
    },
    twoFactor: 'Autenticazione a due fattori',
    enabled: 'Attivato',
    notEnabled: 'Non attivato',
    data: 'Dati e privacy',
    exportData: 'Esporta i miei dati',
    exportDataDesc: 'Scarica una copia di tutti i tuoi dati',
    danger: 'Zona di pericolo',
    signOut: 'Esci',
    deleteAccount: 'Elimina account',
    deleteAccountDesc: 'Elimina definitivamente il tuo account e tutti i tuoi dati',
    deleteConfirmTitle: 'Elimina account',
    deleteConfirmSubtitle: 'Questa azione è permanente',
    deleteConfirmBody: 'Tutti i tuoi viaggi, spese, prenotazioni e dati personali verranno eliminati definitivamente. Questa azione non può essere annullata.',
    deleting: 'Eliminazione…',
    deletePermanently: 'Elimina definitivamente',
    saveFirst: 'Vuoi salvare i tuoi dati prima?',
    exportFailed: 'Impossibile esportare i dati. Riprova.',
    deleteFailed: "Impossibile eliminare l'account. Riprova.",
  },
  docs: {
    hero: {
      title: 'Documentazione di Gromly',
      subtitle: 'Tutto quello che devi sapere per pianificare, collaborare e viaggiare con Gromly.',
      back: 'Torna alla dashboard',
    },
    sidebar: { sections: 'Sezioni' },
    footer: { title: 'Pronto per pianificare?', subtitle: 'Torna alla dashboard e crea il tuo primo viaggio.', cta: 'Vai alla dashboard' },
    itinerary: {
      title: 'Itinerario', subtitle: 'Pianifica le tue giornate, ora per ora',
      p1: "L'itinerario è il cuore del tuo viaggio. Aggiungi attività a ogni giorno, riordinale trascinandole, e ogni nuovo giorno continua automaticamente da dove è finito il precedente.",
      feat_addDay_label: 'Aggiungi giorno', feat_addDay_desc: 'Clicca "Aggiungi giorno" per creare un nuovo giorno. Le date vengono assegnate automaticamente dalla data di inizio del viaggio.',
      feat_drag_label: 'Trascina e rilascia', feat_drag_desc: 'Riordina le attività all\'interno di un giorno trascinando la maniglia.',
      feat_ai_label: 'Pianificazione con IA', feat_ai_desc: 'Clicca il pulsante IA per aprire la chat. Chiedi di aggiungere attività, suggerire cosa visitare o spostare elementi.',
      tip1: 'Passa tra le viste Lista e Cronologia con il selettore nell\'intestazione. La vista Cronologia unisce voli, hotel e attività in un unico feed cronologico.',
      step1: 'Clicca "Aggiungi giorno" per creare il tuo primo giorno.',
      step2: 'Clicca "+ Aggiungi attività" per aggiungere attività al giorno.',
      step3: 'Compila il titolo, il tipo (Ristorante, Monumento, ecc.) e i dettagli facoltativi.',
      step4: 'Trascina le attività per riordinarle all\'interno del giorno.',
    },
    places: {
      title: 'Luoghi', subtitle: 'La tua wishlist personale per la destinazione',
      p1: 'Luoghi è la tua lista curata di posti da visitare: ristoranti da provare, monumenti da vedere, quartieri da esplorare, negozi da visitare. Tutto organizzato per categoria.',
      feat_add_label: 'Aggiungi luogo', feat_add_desc: 'Usa il pulsante "+ Aggiungi luogo" o chiedi all\'IA di aggiungerlo con arricchimento automatico di Google Maps.',
      feat_visited_label: 'Segna come visitato', feat_visited_desc: 'Tocca il segno di spunta sulla scheda del luogo una volta che ci sei stato. I luoghi visitati diventano grigi ma rimangono nella lista.',
      feat_ai_label: 'Raccomandazioni IA', feat_ai_desc: 'Apri la chat IA e chiedi "Dammi 5 raccomandazioni di ristoranti nel centro storico". Li aggiungerà direttamente alla tua lista.',
      tip1: 'I luoghi aggiunti qui appaiono automaticamente come opzioni pin nella scheda Mappa. Puoi collegare un luogo direttamente a un\'attività dell\'itinerario con il pulsante "Aggiungi all\'itinerario".',
    },
    map: {
      title: 'Mappa', subtitle: 'Visualizza percorsi e ottimizza la tua giornata',
      p1: 'La scheda Mappa mostra tutti i tuoi luoghi salvati come pin. Seleziona un giorno dal menu a tendina per vedere solo le attività di quel giorno con un percorso tracciato tra loro.',
      feat_route_label: 'Percorso del giorno', feat_route_desc: 'Seleziona un giorno per vedere un percorso collegato tra tutte le attività in ordine. Tocca un pin per vedere i dettagli dell\'attività.',
      feat_reorder_label: 'Riordina tappe', feat_reorder_desc: 'Nel pannello del percorso, trascina le tappe per cambiarne l\'ordine. Il percorso sulla mappa si aggiorna in tempo reale.',
      feat_ai_label: 'Ottimizza con gIA', feat_ai_desc: 'Tocca "Ottimizza con gIA" per lasciare che l\'IA riordini le tue tappe geograficamente minimizzando i tragitti.',
      tip1: 'Su mobile, il pannello del percorso sale dal basso come un foglio. Scorri verso il basso per nasconderlo e ottenere una vista mappa a schermo intero.',
    },
    bookings: {
      title: 'Prenotazioni', subtitle: 'Voli, hotel, trasporti e biglietti — tutto in un posto',
      p1: 'Prenotazioni centralizza tutte le prenotazioni del tuo viaggio: voli di andata e ritorno, check-in hotel, tratte di trasporto (treno, bus, taxi) e biglietti per eventi o attività.',
      feat_flights_label: 'Voli', feat_flights_desc: 'Aggiungi voli di andata e ritorno con compagnia aerea, numero di volo, aeroporti e riferimento prenotazione.',
      feat_hotels_label: 'Hotel', feat_hotels_desc: 'Registra il tuo alloggio con date di check-in e check-out, indirizzo e URL di prenotazione.',
      feat_bookings_label: 'Prenotazioni e biglietti', feat_bookings_desc: 'Aggiungi qualsiasi altra prenotazione: teatro, partita di calcio, ingresso museo, biglietto bus — con data, luogo e riferimento.',
      feat_docs_label: 'Allega documenti', feat_docs_desc: 'Carica PDF, screenshot, foto o la email di conferma stessa (.eml) direttamente a una prenotazione. Archiviati in modo sicuro nel cloud.',
      tip1: 'Salva la email di conferma come .eml e caricala così com\'è: l\'IA legge il messaggio e i biglietti allegati, e resta accessibile offline. L\'app mostrerà un promemoria 48 ore prima di ogni volo o check-in hotel.',
      warning1: 'I caricamenti di documenti richiedono che Cloudflare R2 sia configurato nel server. Contatta il tuo amministratore se il pulsante di caricamento è disabilitato.',
    },
    expenses: {
      title: 'Spese e budget', subtitle: 'Traccia le spese e salda i debiti automaticamente',
      p1: 'La scheda Spese è un tracker completo di spese di gruppo. Registra cosa è stato speso, chi ha pagato, come viene diviso nel gruppo, e lascia che l\'app calcoli il modo più semplice per saldare.',
      feat_add_label: 'Aggiungi spesa', feat_add_desc: 'Registra chi ha pagato, l\'importo, la valuta, la categoria (Alloggio, Cibo, Trasporto…) e come dividerla.',
      feat_settle_label: 'Liquidazione automatica', feat_settle_desc: 'Clicca "Ricalcola" per ottenere l\'insieme minimo di pagamenti che salda tutti i debiti.',
      feat_debt_label: 'Salda debito', feat_debt_desc: 'Una volta saldato un debito nella vita reale, tocca "Salda" per marcarlo come fatto. I debiti saldati vengono conservati per riferimento.',
      feat_budget_label: 'Tracker budget', feat_budget_desc: 'Tocca l\'icona matita sulla scheda Budget per impostare un budget totale. Una barra di avanzamento mostra quanto hai usato per categoria.',
      tip1: 'La barra del budget diventa ambra quando raggiungi l\'80% e rossa quando lo superi. Impostala all\'inizio del viaggio per sapere sempre dove sei.',
      step1: 'Apri Spese e clicca "Aggiungi spesa".', step2: 'Seleziona chi ha pagato e l\'importo.',
      step3: 'Scegli come dividere: in parti uguali o importi personalizzati.',
      step4: 'Dopo aver aggiunto diverse spese, clicca "Ricalcola" per ottenere il piano di liquidazione.',
      step5: 'Quando viene effettuato un pagamento, tocca "Salda" per chiudere il debito.',
    },
    info: {
      title: 'Info e consigli', subtitle: 'Consigli, checklist e conoscenza locale',
      p1: 'Info e Consigli ha due sezioni: una bacheca libera di consigli organizzata per categoria (Trasporti, Cibo, Cultura, Denaro…) e checklist pre-viaggio per fare i bagagli e prepararsi.',
      feat_tips_label: 'Consigli', feat_tips_desc: 'Aggiungi brevi consigli per categoria. Ottimo per note come "La metro chiude a mezzanotte" o "Prenota ristoranti 2 settimane prima".',
      feat_checklists_label: 'Checklist', feat_checklists_desc: 'Crea sezioni di checklist (Documenti, Abbigliamento, Elettronica…) e aggiungi elementi a ciascuna. Spuntali mentre fai i bagagli.',
      feat_ai_label: 'Lista bagagli con IA', feat_ai_desc: 'Clicca "Genera con IA" per ottenere una lista bagagli personalizzata in base alla tua destinazione, durata, stagione e attività pianificate.',
      tip1: 'La lista bagagli con IA viene generata come sezioni di checklist così puoi modificarla, aggiungere o rimuovere elementi in seguito. È un punto di partenza, non una lista fissa.',
      step1: 'Aggiungi una sezione checklist (es. "Documenti") con il campo di testo in basso.',
      step2: 'Digita gli elementi uno alla volta e premi Invio per aggiungerli.',
      step3: 'O clicca "Genera con IA" per creare automaticamente una lista bagagli completa.',
      step4: 'Mentre fai i bagagli, spunta gli elementi. La barra di avanzamento in alto traccia il completamento.',
    },
    ai: {
      title: 'Assistente IA', subtitle: 'Il tuo compagno di viaggio intelligente',
      p1: "L'assistente IA è consapevole del contesto — conosce la tua destinazione, le date del viaggio e cosa c'è già nel tuo viaggio. Funziona diversamente a seconda della scheda in cui ti trovi.",
      feat_places_label: 'Modalità Luoghi', feat_places_desc: 'Scrivi "Aggiungi la Sagrada Família ai miei luoghi" e la troverà su Google Maps, compilerà l\'indirizzo e creerà il luogo automaticamente.',
      feat_itinerary_label: 'Modalità Itinerario', feat_itinerary_desc: 'Chiedigli di aggiungere attività a giorni e fasce orarie specifici, o di spostare attività esistenti. Vede il tuo itinerario attuale.',
      feat_route_label: 'Modalità Percorso', feat_route_desc: 'Nella scheda Mappa, chiedigli di riordinare le tappe del giorno selezionato, minimizzando i tempi di percorrenza tra le zone.',
      feat_packing_label: 'Modalità Bagagli', feat_packing_desc: 'In Info e Consigli, genera una lista bagagli completa adattata alla tua destinazione, stagione e tipo di attività.',
      tip1: 'Parla con l\'IA in qualsiasi lingua — risponderà nella lingua che usi. Sii specifico: "Aggiungi 3 bar di tapas vicino al Quartiere Gotico per cena" funziona meglio di "Aggiungi ristoranti".',
      warning1: 'L\'IA richiede una chiave API OpenAI configurata nel server. Se il pulsante della chat IA è disabilitato o restituisce un errore, chiedi al tuo amministratore di verificare la chiave.',
    },
    sharing: {
      title: 'Condividi viaggio', subtitle: 'Lascia che chiunque veda il tuo viaggio senza account',
      p1: 'La funzione Condividi viaggio genera un link pubblico unico che permette a chiunque — anche senza account — di vedere il tuo viaggio in sola lettura: itinerario, voli, hotel e note.',
      feat_enable_label: 'Abilita condivisione', feat_enable_desc: 'Nella barra laterale del viaggio, clicca "Condividi viaggio" poi "Abilita condivisione". Viene generato immediatamente un URL unico.',
      feat_copy_label: 'Copia link', feat_copy_desc: 'Copia il link e invialo a familiari o amici. Possono vedere l\'itinerario completo ma non modificare nulla.',
      feat_disable_label: 'Disabilita condivisione', feat_disable_desc: 'Clicca "Disabilita condivisione" in qualsiasi momento per invalidare il link. Chi ha il vecchio URL vedrà una pagina "Non trovato".',
      tip1: 'La vista condivisa è una pagina pulita e ottimizzata per mobile senza login richiesto. Perfetta per inviare l\'itinerario a un familiare che vuole seguire il tuo viaggio.',
      warning1: 'Solo il proprietario del viaggio può abilitare o disabilitare la condivisione. I partecipanti con ruoli EDITOR o VIEWER non possono gestire il link.',
    },
    participants: {
      title: 'Partecipanti', subtitle: 'Invita e gestisci il tuo gruppo di viaggio',
      p1: 'Invita co-viaggiatori per collaborare al viaggio. Ogni partecipante ha un ruolo che controlla cosa può fare.',
      feat_invite_label: 'Invita per email', feat_invite_desc: 'L\'invitato deve avere già un account. Inserisci la sua email e scegli un ruolo.',
      feat_editor_label: 'Ruolo EDITOR', feat_editor_desc: 'Può aggiungere, modificare ed eliminare contenuti: attività, luoghi, spese, prenotazioni, consigli e checklist.',
      feat_viewer_label: 'Ruolo VIEWER', feat_viewer_desc: 'Accesso sola lettura. Può vedere tutto ma non fare modifiche. Ideale per chi vuole seguire il piano.',
      tip1: 'Solo il proprietario può invitare partecipanti, cambiare il loro ruolo o rimuoverli. Il proprietario è anche l\'unico che può eliminare l\'intero viaggio.',
      step1: "Nella barra laterale del viaggio, clicca il pulsante partecipanti (mostra avatar e numero di membri). Su mobile, tocca l'icona delle persone nell'intestazione del viaggio.",
      step2: 'Clicca "Invita partecipante" e inserisci l\'indirizzo email.',
      step3: 'Scegli EDITOR (può modificare) o VIEWER (sola lettura).',
      step4: 'Il partecipante vedrà il viaggio nella sua dashboard immediatamente.',
    },
    notifications: {
      title: 'Notifiche', subtitle: 'Promemoria in-app per eventi imminenti',
      p1: 'L\'app mostra promemoria in-app quando una partenza volo o un check-in hotel è entro le prossime 48 ore. Nessuna impostazione necessaria — funziona automaticamente.',
      feat_flights_label: 'Promemoria voli', feat_flights_desc: 'Mostrati 48h prima della partenza. Urgente (rosso) entro 12 ore.',
      feat_hotels_label: 'Promemoria hotel', feat_hotels_desc: 'Mostrati 48h prima del check-in. Urgente (rosso) entro 12 ore.',
      feat_where_label: 'Dove trovarli', feat_where_desc: 'Desktop: pannello ambra nella barra laterale del viaggio. Mobile: badge rosso sulla scheda Prenotazioni nella barra di navigazione inferiore.',
      tip1: 'I promemoria sono calcolati dai tuoi voli e hotel nella scheda Prenotazioni. Assicurati di aggiungere gli orari di partenza effettivi per ricevere avvisi accurati.',
    },
    community: {
      title: 'Esplora la community', subtitle: 'Scopri, valuta e clona viaggi di altri viaggiatori',
      p1: 'La sezione Esplora è un feed pubblico di viaggi condivisi dalla community di Gromly. Sfoglia destinazioni, scopri itinerari creati da viaggiatori reali e clona qualsiasi viaggio come punto di partenza.',
      feat_browse_label: 'Sfoglia e cerca', feat_browse_desc: 'Filtra per destinazione o durata e ordina per Più recenti, Meglio valutati o Più usati. Usa la barra di ricerca per una destinazione specifica.',
      feat_clone_label: 'Clona un viaggio', feat_clone_desc: 'Clicca su "Usa questo itinerario" per creare una copia completa nella tua dashboard. Il clone è indipendente — le tue modifiche non influenzano l\'originale.',
      feat_rate_label: 'Valuta i viaggi', feat_rate_desc: 'Lascia una valutazione da 1 a 5 stelle su qualsiasi viaggio pubblicato. Le valutazioni aiutano a mettere in evidenza i migliori itinerari.',
      feat_follow_label: 'Segui viaggiatori', feat_follow_desc: 'Segui altri utenti per filtrare il feed sui loro viaggi. Usa la scheda "Seguiti" per vedere le loro ultime pubblicazioni.',
      tip1: 'Per pubblicare il tuo viaggio, vai nella Dashboard, apri il menu del viaggio (tre punti) e clicca su "Condividi con la community".',
      step1: 'Vai su Esplora dalla barra di navigazione in alto.',
      step2: 'Usa la barra di ricerca o le opzioni di ordinamento per trovare viaggi.',
      step3: 'Clicca su una scheda viaggio per vedere l\'itinerario completo.',
      step4: 'Clicca su "Usa questo itinerario" per clonarlo nella tua dashboard.',
    },
    account: {
      title: 'Account e sicurezza', subtitle: '2FA, controlli sulla privacy e i tuoi dati',
      p1: 'Le impostazioni del tuo account sono accessibili dal menu utente (angolo in alto a destra). Da lì puoi gestire l\'autenticazione a due fattori, scaricare i tuoi dati ed eliminare l\'account.',
      feat_2fa_label: 'Autenticazione a due fattori', feat_2fa_desc: 'Clicca su "Sicurezza" nel menu utente per configurare il 2FA. Scansiona il QR code con Google Authenticator, Authy o qualsiasi app TOTP.',
      feat_export_label: 'Scarica i miei dati', feat_export_desc: 'Clicca su "Scarica i miei dati" nel menu utente per esportare tutti i tuoi dati personali in JSON (GDPR Art. 20 — portabilità).',
      feat_delete_label: 'Elimina account', feat_delete_desc: 'Clicca su "Elimina account" per eliminare definitivamente il tuo account e tutti i dati associati. Questa azione è irreversibile.',
      tip1: 'Ti consigliamo vivamente di attivare il 2FA — protegge il tuo account anche se la password viene compromessa. Usa Google Authenticator, Authy, 1Password, ecc.',
      warning1: 'L\'eliminazione dell\'account è permanente e irreversibile. Tutti i tuoi viaggi, spese, prenotazioni e documenti verranno eliminati. Scarica i tuoi dati prima se vuoi una copia.',
    },
    pwa: {
      title: 'Installa come app (PWA)', subtitle: 'Usa Gromly offline su qualsiasi dispositivo',
      p1: 'Gromly è una Progressive Web App (PWA). Puoi installarla sul tuo telefono o desktop e usarla come un\'app nativa — anche senza connessione internet.',
      feat_ios_label: 'Installa su iOS', feat_ios_desc: 'Apri Gromly in Safari → tocca il pulsante Condividi → "Aggiungi alla schermata Home". Fatto.',
      feat_android_label: 'Installa su Android', feat_android_desc: 'Apri in Chrome → tocca il menu a tre punti → "Aggiungi alla schermata Home" o "Installa app".',
      feat_desktop_label: 'Installa su desktop', feat_desktop_desc: 'In Chrome o Edge, cerca l\'icona di installazione (➕) nella barra degli indirizzi e cliccala.',
      tip1: 'Gromly memorizza nella cache i tuoi viaggi, itinerario e prenotazioni così si caricano istantaneamente anche senza connessione. La consultazione funziona offline; aggiungere o modificare qualcosa richiede ancora una connessione.',
    },
  },
  installPrompt: {
    title: 'Installa Gromly',
    subtitle: 'Aggiungila alla schermata Home per un accesso rapido a schermo intero.',
    install: 'Installa',
    iosIntro: 'Per installarla sul tuo iPhone:',
    iosStep1: 'Tocca il pulsante Condividi',
    iosStep2: 'Scegli «Aggiungi a Home»',
  },
  maps: {
    quotaExceeded: 'Hai raggiunto il limite di Maps di questo mese. Si azzera il {{date}}.',
  },
  ai: {
    deleteActivity: 'Elimina attività',
    venueNotes: {
      title: 'Riscrivere le note di {{name}}', titleNew: 'Note per {{name}}',
      before: 'Ora', after: 'Proposta', emptied: '(note vuote)',
    },
    deletePlaces_one: 'Elimina il luogo',
    deletePlaces_other: 'Elimina {{count}} luoghi',
    deleteAllPlaces_one: 'Svuota la lista dei luoghi ({{count}} luogo)',
    deleteAllPlaces_other: 'Svuota la lista dei luoghi ({{count}} luoghi)',
    deleteTakesStops_one: 'Rimuove anche {{count}} tappa dall\'itinerario',
    deleteTakesStops_other: 'Rimuove anche {{count}} tappe dall\'itinerario',
    deleteExpenses_one: 'Elimina la spesa',
    deleteExpenses_other: 'Elimina {{count}} spese',
    deleteAllExpenses_one: 'Svuota il libro dei conti ({{count}} spesa)',
    deleteAllExpenses_other: 'Svuota il libro dei conti ({{count}} spese)',
    assistant: 'Assistente IA',
    name: 'gIA',
    expand: "Apri l'assistente",
    collapse: "Comprimi l'assistente",
    saveFailed: 'Impossibile salvare',
    someNotSaved: 'Alcune proposte non hanno potuto essere salvate',
    error: 'Spiacente, si è verificato un errore. Riprova.',
    clearConversation: 'Cancella conversazione',
    expenseSplitHint: 'Paghi tu; diviso in parti uguali. Modifica il dettaglio in Spese.',
    proposals_one: '{{count}} proposta',
    proposals_other: '{{count}} proposte',
    saving: 'Salvataggio…',
    op: {
      tripDates: {
        title: 'Nuove date: {{from}} → {{to}}',
        addedDays_one: 'Si aggiunge {{count}} giorno',
        addedDays_other: 'Si aggiungono {{count}} giorni',
        removedDays_one: 'Si toglie {{count}} giorno',
        removedDays_other: 'Si tolgono {{count}} giorni',
        movedStops_one: '{{count}} tappa passa al giorno {{day}}',
        movedStops_other: '{{count}} tappe passano al giorno {{day}}',
        removedMeals_one: 'Si perde {{count}} pasto previsto',
        removedMeals_other: 'Si perdono {{count}} pasti previsti',
        removedOutfitDays_one: 'Si perdono i vestiti previsti di {{count}} giorno',
        removedOutfitDays_other: 'Si perdono i vestiti previsti di {{count}} giorni',
        outOfRange_one: '{{count}} prenotazione resta fuori dalle nuove date',
        outOfRange_other: '{{count}} prenotazioni restano fuori dalle nuove date',
      },
      settleDebt: {
        title: '{{from}} ha pagato {{amount}} a {{to}}',
      },
      outfitAdd: {
        title: 'Indossare {{item}} il giorno {{day}}',
      },
      ingredientAdd: {
        title: 'Aggiungere {{amount}} {{unit}} di {{name}} a «{{meal}}»',
      },
      mealStop: {
        title: 'Mettere «{{meal}}» come tappa del giorno {{day}}',
      },
      duplicate: {
        title_one: 'Copia {{count}} tappa al giorno {{day}}',
        title_other: 'Copia {{count}} tappe al giorno {{day}}',
      },
      item: '– {{text}}',
    },
    cards: {
      empty: '(vuoto)',
      field: {
        title: 'Titolo',
        notes: 'Note',
        startTime: 'Ora',
        durationMins: 'Durata (min)',
        name: 'Nome',
        category: 'Categoria',
        customCategory: 'Categoria propria',
        zone: 'Zona',
        priceInfo: 'Prezzo',
        visited: 'Visitato',
        airline: 'Compagnia',
        flightNumber: 'Numero di volo',
        departureTime: 'Partenza',
        arrivalTime: 'Arrivo',
        bookingRef: 'Codice prenotazione',
        address: 'Indirizzo',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        bookingUrl: 'Link prenotazione',
        type: 'Tipo',
        date: 'Data',
        endDate: 'Data di fine',
        endTime: 'Ora di fine',
        venue: 'Luogo',
        description: 'Descrizione',
        amount: 'Importo',
        content: 'Testo',
        text: 'Articolo',
        checked: 'In valigia',
        slot: 'Pasto',
        bought: 'Comprato',
        unit: 'Unità',
      },
      entity: {
        day_one: 'giorno', day_other: 'giorni',
        venue_one: 'luogo', venue_other: 'luoghi',
        flight_one: 'volo', flight_other: 'voli',
        hotel_one: 'alloggio', hotel_other: 'alloggi',
        booking_one: 'prenotazione', booking_other: 'prenotazioni',
        expense_one: 'spesa', expense_other: 'spese',
        note_one: 'nota', note_other: 'note',
        tip_one: 'consiglio', tip_other: 'consigli',
        packing_section_one: 'sezione della valigia', packing_section_other: 'sezioni della valigia',
        packing_item_one: 'articolo della valigia', packing_item_other: 'articoli della valigia',
        outfit_piece_one: 'capo previsto', outfit_piece_other: 'capi previsti',
        meal_one: 'pasto', meal_other: 'pasti',
        grocery_item_one: 'voce della spesa', grocery_item_other: 'voci della spesa',
      },
      yes: 'Sì',
      no: 'No',
      editItem: 'Modifica «{{label}}»',
      deleteItems_one: 'Elimina {{count}} elemento',
      deleteItems_other: 'Elimina {{count}} elementi',
      packed: '✓ {{item}} in valigia',
      unpacked: '○ {{item}} ancora da mettere',
      nights_one: '{{count}} notte',
      nights_other: '{{count}} notti',
      at: 'A {{place}}',
      editStop: 'Modifica «{{title}}»',
      packingItems: 'Valigia',
      note: 'Nota',
      day: 'Giorno {{n}}',
      grocery: 'Lista della spesa',
      flight: 'Volo',
      stay: 'Alloggio',
      booking: 'Prenotazione',
    },
    acceptAll: 'Accetta tutto',
    accept: 'Accetta',
    discard: 'Scarta',
    sendHint: 'Invio per inviare · Shift+Invio nuova riga',
    open: 'Aperto',
    closed: 'Chiuso',
    willSaveToPlaces: 'Salvato in Luoghi',
    move: 'Sposta: {{title}}',
    afterStop: 'dopo {{title}}',
    placeholder: {
      places: '"Voglio salvare un ristorante nel Barrio Gótico"',
      itinerary: '"Aggiungi una visita alla Sagrada Família il giorno 2"',
      allroutes: '"Rendi il giorno 2 un percorso circolare" o "Rimuovi la tappa del museo"',
      packing: '"Proponi una lista dei bagagli" o "Aggiungi una sezione mare"',
      tips: '"Dammi consigli su trasporti e denaro"',
      bookings: '"Quanto tempo ho tra i voli in coincidenza?"',
      expenses: '"Quanto abbiamo speso in cibo?" o "Chi deve a chi?"',
      general: "\"Pianificami il giorno 3\" o \"Cosa mi porto?\"",
    },
    welcome: {
      places: "Ciao! Parlami dei posti che vuoi salvare e ti proporrò di aggiungerli alla tua lista di luoghi.",
      itinerary: "Ciao! Posso suggerire attività per il tuo itinerario o spostarle. Decidi tu se accettarle.",
      allroutes: "Ciao! Posso riordinare le tappe per ridurre gli spostamenti, creare percorsi circolari, spostare attività tra i giorni o eliminarne alcune. Decidi tu cosa accettare.",
      packing: "Ciao! Posso proporti una lista dei bagagli su misura per il tuo viaggio. Decidi tu se accettarla.",
      tips: "Ciao! Posso proporti consigli pratici per la tua destinazione. Decidi tu se salvarli.",
      bookings: "Ciao! Chiedimi tutto sui tuoi voli e hotel: orari, coincidenze, check-in e logistica.",
      expenses: "Ciao! Chiedimi delle tue spese, del budget e dei saldi: totali per categoria, chi deve a chi o come dividere i costi.",
      general: "Ciao! Chiedimi quello che vuoi sul viaggio: luoghi, programma, valigia, prenotazioni o spese. Decidi tu cosa tenere.",
    },
    // The vocabulary that unlocks the assistant, made visible: an empty
    // input box teaches nobody what it can do.
    suggestions: {
      general: ["Pianificami il giorno 1", "Proponimi luoghi per i miei interessi", "Cosa mi porto?"],
      places: ["Proponimi luoghi per i miei interessi", "Dove mangiare bene e spendere poco", "Qualcosa da fare se piove"],
      itinerary: ["Pianificami il giorno 1", "Questa giornata è troppo piena", "Aggiungi una cena il giorno 2"],
      allroutes: ["Ottimizza il percorso di questo giorno", "Rendilo circolare", "Sposta questa tappa a un altro giorno"],
      packing: ["Cosa mi porto?", "Qualcosa per il meteo?"],
      tips: ["Consigli per spostarsi", "Cosa dovrei sapere prima di partire?"],
      bookings: ["A che ora atterro?", "Quanto dura il mio scalo?"],
      expenses: ["Quanto ho speso finora?", "Chi deve a chi?", "Sono dentro il budget?"],
    },
    category: {
      RESTAURANT: 'Ristorante', CAFE: 'Caffè', ATTRACTION: 'Attrazione',
      VIEWPOINT: 'Belvedere', NEIGHBORHOOD: 'Quartiere', PARK: 'Parco',
      SHOP: 'Negozio', EXPERIENCE: 'Esperienza', TRANSPORT_HUB: 'Trasporto',
      BEACH: 'Spiaggia', NATURE: 'Natura', PARKING: 'Parcheggio', OTHER: 'Altro',
    },
    context: { places: 'Luoghi', itinerary: 'Itinerario', packing: 'Bagagli', tips: 'Consigli', bookings: 'Prenotazioni', expenses: 'Spese', general: 'Viaggio' },
    packingTitle: 'Lista dei bagagli',
    packingItems_one: '{{count}} articolo',
    packingItems_other: '{{count}} articoli',
    packingGoToTab: 'Apri la scheda Bagaglio',
    budgetTitle: 'Budget proposto',
    dayPlanTitle: 'Piano del giorno',
    dayNumber: 'Giorno {{number}}',
    showPhotos: 'Vedi foto',
    activitiesCount_one: '{{count}} attività',
    activitiesCount_other: '{{count}} attività',
    acceptDay: 'Accetta il giorno',
    reorderTitle: 'Riordina',
    applyOrder: "Applica l'ordine",
    applying: 'Applicazione…',
    review: {
      places: 'Rivedi i luoghi',
      itinerary: 'Rivedi le attività aggiunte',
      packing: 'Rivedi il bagaglio',
      tips: 'Rivedi i consigli',
      expenses: 'Rivedi le spese',
    },
    tipsTitle: 'Consigli',
    tipsCount_one: '{{count}} consiglio',
    tipsCount_other: '{{count}} consigli',
  },
  services: {
    title: 'Servizi del viaggio',
    subtitle: 'Partner selezionati per gestire le cose noiose prima di volare. Attiva prima di partire — paga con Gromly, tieni tutto in questo viaggio.',
    partnership: 'Partner di Gromly.',
    partnershipNote: 'Guadagniamo una piccola commissione quando acquisti tramite i nostri link — il prezzo che paghi rimane uguale o inferiore grazie al nostro codice.',
    connectivity: {
      label: 'Connettività',
      eSIM: 'eSIM',
      coverage: 'Copertura',
      euRoaming: 'Roaming UE',
      heading: 'Connettiti nel momento in cui atterri',
      body: 'Nessun cambio di SIM fisica. Scansiona il QR prima di volare e il tuo telefono aggancia i dati appena l\'aereo tocca terra.',
      editorsPick: 'Scelta della redazione',
      from: 'Da',
      viewPlans: 'Vedi piani',
      holafly: {
        subtitle: 'eSIM con dati illimitati',
        description: 'Il preferito dai blog di viaggio — attivazione immediata, supporto in italiano, piani fino a 30 giorni per i viaggiatori lenti.',
        feature1: 'Piani dati illimitati',
        feature2: 'Chat 24/7 in spagnolo e inglese',
        feature3: '5, 10, 15 o 30 giorni',
        discountNote: '5% di sconto — usa il codice GROMLY al checkout',
        price: '€19',
        priceNote: 'per 5 giorni · {{destination}}', priceNoteGeneric: 'per 5 giorni',
      },
    },
  },
  notes: {
    loadError: 'Impossibile caricare le note', saveError: 'Impossibile salvare la nota',
    createError: 'Impossibile creare la nota', deleteConfirm: 'Eliminare questa nota?',
    deleteError: 'Impossibile eliminare la nota',
    untitled: 'Senza titolo', empty: 'Nessun contenuto',
    new: 'Nuova', emptyState: 'Nessuna nota ancora', createFirst: 'Crea la tua prima nota',
    selectOrCreate: 'Seleziona una nota o creane una nuova',
    allNotes: 'Tutte le note', saved: 'Salvato', delete: 'Elimina nota',
    titleLabel: 'Titolo', contentLabel: 'Contenuto',
    titlePlaceholder: 'Titolo della nota', contentPlaceholder: 'Scrivi qui le tue note…',
    uploadError: 'Impossibile caricare il file', deleteDocError: 'Impossibile eliminare il file',
    attachments: 'Allegati', upload: 'Carica',
    dropHere: 'Clicca per allegare file (immagini o PDF)',
  },
  album: {
    ownPhotos: { title: "Le tue foto per l’album", upload: "Carica", hint: "Solo nel tuo album: non vanno nella Galleria e nessun altro del viaggio le vede.", tripPhotos: "Foto del viaggio", remove: "Togli questa foto dal tuo album" },
    redoDay: { button: "Rifai questo giorno", confirmTitle: "Rifare questo giorno dal diario?", confirmBody_one: "La sua pagina viene rifatta con le foto e il testo del giorno. Ciò che hai modificato va perso.", confirmBody_other: "Le sue {{count}} pagine vengono rifatte con le foto e il testo del giorno. Ciò che hai modificato va perso." },
    wizard: {
      title_create: "Crea il tuo album", title_restart: "Ricomincia l’album", steps: "Passaggi", next: "Avanti",
      submit_create: "Crea album", submit_restart: "Ricomincia", restartWarning: "Tutte le pagine vengono rifatte dal diario. Le foto caricate nell’album restano.",
      format: { step: "Formato", title: "Dimensione e forma", body: "Puoi cambiarlo quando vuoi; le pagine conservano il loro contenuto." },
      theme: { step: "Stile", title: "Lo stile dell’album", body: "Carta e colori. Il carattere e le cornici delle foto sono nell’editor." },
      density: { step: "Foto", title: "Quante foto al giorno?", body: "Le foto scelte nel diario entrano sempre; questo dice solo quante altre se ne aggiungono.",
        FEW: "Poche", FEW_hint: "Fino a 2 al giorno", NORMAL: "Equilibrato", NORMAL_hint: "Fino a 6 al giorno", ALL: "Tutte", ALL_hint: "Tutte le foto di ogni giorno",
        pages_one: "{{count}} pagina", pages_other: "{{count}} pagine", tooLong: "Oltre {{max}} pagine: la fine viene tagliata" },
      cover: { step: "Copertina", title: "La foto di copertina", body: "Potrai cambiarla dopo dalla pagina di copertina." },
    },
    emptyTitle: 'Il tuo album del viaggio',
    emptyBody: 'Lo iniziamo con il tuo diario e le tue foto, una pagina al giorno. Poi scegli il layout, le foto e i testi. Lo vedi solo tu.',
    create: 'Crea il mio album',
    loadError: 'Impossibile caricare il tuo album', saveError: "Impossibile salvare l'album",
    page: 'Pagina {{number}}', template: 'Layout', addPage: 'Aggiungi pagina',
    deletePageN: 'Elimina la pagina {{number}}',
    deletePage: 'Elimina pagina', deletePageConfirm: "Eliminare questa pagina dell'album?",
    restart: 'Ricomincia dal diario',
    templates: { COVER: 'Copertina', STATS: 'In cifre', ONE_PHOTO: 'Una foto', TWO_PHOTOS: 'Due foto', THREE_PHOTOS: 'Tre foto', FOUR_PHOTOS: 'Quattro foto', TEXT_PHOTO: 'Testo e foto', TRIP_MAP: "Mappa del viaggio", DAY_MAP: "Mappa del giorno", TEXT_ONLY: 'Testo', FULL_BLEED: 'Al vivo', TWO_PHOTOS_ASYM: 'Grande e piccola', THREE_STRIPS: 'Tre strisce', FIVE_PHOTOS: 'Cinque foto', SIX_PHOTOS: 'Sei foto', MOSAIC: 'Mosaico', TWO_PHOTOS_TEXT: 'Due foto e testo', QUOTE: 'Citazione', PANORAMA: 'Panoramica', PANORAMA_FRAMED: 'Panoramica con margini', TRIP_MAP_SPREAD: 'Mappa a doppia pagina', COVER_WRAP: 'Foto avvolgente', COVER_FULL: "Foto a tutta pagina", COVER_TYPE: "Tipografica", COVER_FRAMED: "Foto incorniciata", COVER_MOSAIC: "Quattro foto", COVER_MAP: "Mappa del viaggio", COVER_WRAP_FRAMED: "Copertina incorniciata", COVER_WRAP_TWO: "Copertina a due foto" },
    spread: { cover: 'Copertina', back: 'Quarta di copertina', front: 'Prima di copertina', wrap: 'Copertina intera', pages: 'Pagine {{pages}}', add: 'Aggiungi due pagine', delete: 'Elimina queste due pagine', deleteN: 'Elimina le pagine {{pages}}', deleteConfirm: "Eliminare queste due pagine dell'album?", swap: 'Scambia sinistra e destra', endpaper: 'Interno della copertina: qui non si stampa nulla', join: 'Uniscile', joinTitle: 'Unire le due pagine?', joinBody: 'Questo layout occupa entrambe le pagine. Quello che non ci sta della pagina di fronte andrà perso.' },
    spine: { title: 'Dorso', placeholder: 'Titolo sul dorso', width: 'Circa {{mm}} mm di larghezza: quella esatta dipende dalla tipografia.', tooThin: 'Circa {{mm}} mm: un titolo ne richiede {{min}}. Aggiungi pagine per fargli spazio.' },
    templateGroups: { label: "Vai ai layout", covers: "Copertine", '1': '1', '2': '2', '3': '3', '4+': '4+', text: 'Testo', map: 'Mappa', spread: 'Doppia pagina' },
    templateSections: { 'covers': "Copertine", '1': "Una foto", '2': "Due foto", '3': "Tre foto", '4+': "Quattro foto o più", 'text': "Testo", 'map': "Mappe e cifre", 'spread': "Doppia pagina" },
    slot: { PHOTO: 'Aggiungi una foto', TITLE: 'Aggiungi un titolo', TEXT: 'Aggiungi testo', MAP: "Scegli il giorno" },
    statsTitle: 'Il viaggio in cifre',
    choosePhoto: 'Scegli una foto', removePhoto: 'Togli la foto', used: 'Usata',
    noPhotos: 'Questo viaggio non ha ancora foto. Caricale nel Diario.',
    selectHint: 'Clicca un riquadro della pagina per riempirlo, o trascinaci sopra una foto.',
    chars: '{{count}} / {{max}}', tooLong: 'Troppo lungo per questo riquadro: accorcialo o scegli un layout con più spazio.',
    fromDiary: 'Inserisci dal diario', entryOption: 'Giorno {{number}} · {{text}}',
    dayN: "Giorno {{n}}", chooseDay: "Scegli il giorno",
    tripMapHint: "La mappa del viaggio si disegna da sola con il tuo itinerario: ogni giorno, nel suo colore.",
    figures: { legend: "Legenda", map: "Mappa", world: "Mondo", country: "Paese", show: "Mostra", route: "Percorso", stops: "Solo punti", outline: "Contorno", outlineShow: "Mostra", outlineHide: "Nascondi", kmCaption: "Chilometri su strada" },
    preview: { open: "Sfoglia", title: "Anteprima dell'album", prev: "Pagina precedente", next: "Pagina successiva" },
    style: { typeface: "Tipografia", font: "Carattere", fontOfAlbum: "Quello dell'album", sizeDown: "Più piccolo", sizeUp: "Più grande", photoFrame: "Cornice delle foto", textSize: "Dimensione del testo", textAlign: "Allineamento", size_S: "Piccolo", size_M: "Medio", size_L: "Grande", align_left: "Sinistra", align_center: "Centro", align_right: "Destra", theme: "Tema dell'album", pageBackground: "Sfondo di questa pagina", fromTheme: "Tema", veil: "Velo", veil_dark: "Velo scuro", veil_light: "Velo chiaro", removePhoto: "Togli la foto", photoBackground: "Metti una foto di sfondo" },
    themes: { paper: "Carta", minimal: "Minimal", night: "Notte", sand: "Sabbia", sage: "Salvia", kraft: "Kraft" },
    backgrounds: { paper: "Carta", white: "Bianco", sand: "Sabbia", sage: "Salvia", sky: "Cielo", blush: "Rosa", kraft: "Kraft", night: "Notte", forest: "Bosco", ink: "Inchiostro", "paper-dots": "Carta a pois", "paper-grid": "Carta a quadretti", "white-notebook": "Quaderno", "sand-stripes": "Sabbia a righe", "sage-dots": "Salvia a pois", "night-dots": "Notte stellata" },
    format: { title: "Formato e orientamento", "a4-portrait": "A4 verticale", "a5-portrait": "A5 verticale", "a4-landscape": "A4 orizzontale", "a5-landscape": "A5 orizzontale", "square-30": "Quadrato 30", "square-20": "Quadrato 20" },
    fontPairs: { classic: "Classica", modern: "Moderna", handwritten: "Scritta a mano", typewriter: "Macchina da scrivere", elegant: "Elegante", editorial: "Editoriale", rounded: "Arrotondata", poster: "Manifesto", script: "Calligrafia", retro: "Retrò" },
    photoFrames: { none: "Senza cornice", "white-border": "Bordo bianco", rounded: "Arrotondata", shadow: "Ombra" },
    tabs: { page: "Pagina", album: "Album" },
  },
  journal: {
    views: { list: 'Elenco', map: 'Mappa' },
    map: { empty: 'Ancora nessuna foto sulla mappa', emptyBody: 'Una foto compare qui quando è collegata a una tappa con una posizione.', unavailable: 'La mappa non è disponibile al momento.', unplaced_one: '{{count}} foto senza luogo', unplaced_other: '{{count}} foto senza luogo' },
    title: 'Diario',
    empty: { title: 'Ancora niente di scritto', body: 'Scegli un giorno e racconta cosa avete fatto, con le vostre foto.' },
    write: 'Scrivi',
    placeholder: 'Cosa avete fatto oggi? Cosa vorrete ricordare?',
    choosePhotos_one: '{{count}} foto scelta',
    choosePhotos_other: '{{count}} foto scelte',
    addPhotos: 'Aggiungi foto',
    noPhotosToChoose: 'Ancora nessuna foto di questo giorno. Aggiungile da qui.',
    sharedLabel: 'La vedranno i follower del link',
    sharedHint: 'Togli la spunta per tenere questa voce solo per il gruppo.',
    groupOnly: 'Solo il gruppo',
    groupOnlyHint: 'I follower del link non vedono questa voce',
    deleteConfirm: 'Eliminare questa voce del diario? Le sue foto restano nel viaggio.',
    loadError: 'Impossibile caricare il diario',
    saveError: 'Impossibile salvare la voce',
    deleteError: 'Impossibile eliminare la voce',
    previousPhoto: 'Foto precedente',
    nextPhoto: 'Foto successiva',
  },
  stats: {
    title: 'I tuoi viaggi',
    km: 'km',
    days_one: 'giorno', days_other: 'giorni',
    stops_one: 'tappa', stops_other: 'tappe',
    photos_one: 'foto', photos_other: 'foto',
    entries_one: 'voce', entries_other: 'voci',
    trips_one: 'viaggio', trips_other: 'viaggi',
    nights_one: 'notte', nights_other: 'notti',
    countries_one: 'paese', countries_other: 'paesi',
    regions_one: 'continente', regions_other: 'continenti',
    mapLabel_one: 'Mappa con {{count}} paese visitato', mapLabel_other: 'Mappa con {{count}} paesi visitati',
  },
  gallery: {
    noStop: 'Nessuna tappa', stopLabel: 'Tappa',
    title: 'Galleria', upload: 'Carica foto', uploading: 'Caricamento…',
    empty: {
      title: 'Ancora nessuna foto', dayTitle: 'Ancora nessuna foto per questo giorno',
      subtitle: 'Trascinale qui o caricale dal tuo dispositivo.',
    },
    allDays: 'Tutte',
    dayOption: 'Giorno {{number}}', unassignedDay: 'Nessun giorno', uploadedBy: 'Di {{name}}',
    download: 'Scarica originale', delete: 'Elimina foto',
    deleteConfirm: 'Eliminare questa foto? Non si può annullare.',
    loadError: 'Impossibile caricare le foto', uploadError: 'Impossibile caricare {{name}}',
    deleteError: 'Impossibile eliminare la foto', moveError: 'Impossibile spostare la foto',
    selection: { moveToDay: "Sposta a un giorno", searchStop: "Cerca una tappa", noStopMatch: "Nessuna tappa corrisponde", count_one: "{{count}} selezionata", count_other: "{{count}} selezionate", all: "Seleziona tutto", none: "Deseleziona tutto", selectPhoto: "Seleziona foto", unselectPhoto: "Deseleziona foto", place: "Assegna luogo", stopHint: "Le foto di un altro giorno passano al giorno del luogo scelto.", deleteConfirm_one: "Eliminare questa foto? Non si può annullare.", deleteConfirm_other: "Eliminare {{count}} foto? Non si può annullare.", updated_one: "{{count}} foto aggiornata", updated_other: "{{count}} foto aggiornate", updateFailed: "Non è stato possibile modificare {{count}} foto su {{total}}", deleted_one: "{{count}} foto eliminata", deleted_other: "{{count}} foto eliminate", deleteFailed: "Non è stato possibile eliminare {{count}} foto su {{total}}" },
    // ADR-0058
    suggest: { button: "Suggerisci luoghi", hint: "L'IA guarda le foto e suggerisce la tappa del viaggio in cui è stata scattata ciascuna. 1 credito IA ogni 10 foto.", title: "Luoghi suggeriti dall'IA", looking: "Analizzo {{count}} foto…", summary: "Tappa trovata per {{found}} foto su {{total}}. Spunta quelle giuste.", none: "Nessun suggerimento", unsure: "Non sicura", alreadyThere: "è già lì", apply: "Applica ({{count}})", privacy: "Le foto vengono inviate a OpenAI per analizzarle.", failed: "Impossibile suggerire luoghi. Riprova." },
    placedByDate_one: '{{count}} foto collocata nel suo giorno in base alla data dello scatto', placedByDate_other: '{{count}} foto collocate nel loro giorno in base alla data dello scatto',
  },
  billing: {
    credits: { label: 'Crediti viaggio' },
    paywall: {
      title: "Passa a PRO",
      description: "Hai usato i viaggi gratuiti. PRO è un piano annuale con viaggi illimitati e fino a 500 richieste IA al mese.",
      perks: ["Viaggi illimitati", "500 richieste IA al mese", "Tutto quello che usi già, senza limiti"],
      cta: "Passa a PRO",
      error: "Impossibile avviare il pagamento. Riprova.",
    },
    aiPaywall: {
      title: "Richieste IA esaurite",
      description: "Hai usato le richieste IA gratuite. PRO ne include 500 al mese.",
      cta: "Passa a PRO",
      error: "Impossibile avviare il pagamento. Riprova.",
    },
    payment: {
      success: "Benvenuto in PRO! Può volerci qualche secondo per vederlo.",
      cancelled: "Pagamento annullato.",
    },
  },
  landing: {
    nav: {
      features: 'Funzioni',
      ai: 'IA',
      community: 'Comunità',
      marketplace: 'Marketplace',
      signIn: 'Accedi',
      getStarted: 'Inizia',
    },
    hero: {
      eyebrow: 'Dove inizia ogni viaggio',
      headline1: 'Pianifica ogni',
      headline2: 'avventura.',
      subheading: "Itinerari, spese, prenotazioni e luoghi da visitare — tutto in un unico posto, condiviso solo con chi viaggia con te.",
      pills: {
        itinerary: 'Itinerario',
        expenses: 'Spese',
        aiRoutes: 'Rotte IA',
        plane: 'Volo',
        bookings: 'Prenotazioni',
        collaborative: 'Collaborativo',
      },
      ctaPrimary: 'Inizia gratis',
      ctaSecondary: 'Accedi',
    },
    mock: {
      nightsLabel: '{{range}} · {{count}} NOTTI',
      tripTitle: 'Estate in Islanda',
      active: 'ATTIVO',
      moreCount: '+{{count}} altri',
      totalSpent: 'SPESO',
      ofBudget: 'di {{amount}} budget',
      activities: 'ATTIVITÀ',
      acrossDays: 'in {{count}} giorni',
      dayHeader: 'GIORNO {{day}} — {{place}}',
      routeOptimized: 'Rotta ottimizzata',
      splitSettled: 'Divisione saldata · {{count}}p',
      aiOptimized: 'IA Ottimizzato · Giorno {{day}}',
      whoOwesWhom: 'CHI DEVE A CHI',
      settle: 'Saldare',
      settledCount: 'SALDATI · {{count}}',
    },
    ticker: {
      label: 'Viaggi pianificati a',
    },
    features: {
      eyebrow: 'Tutto ciò che ti serve',
      headlineLine1: 'Un unico posto per ogni parte',
      headlineLine2Pre: 'del',
      headlineLine2Highlight: 'viaggio.',
      description: "Pensato per viaggi reali, non idealizzati. Tieni traccia di tutto, dal volo alla prenotazione della cena.",
      cards: {
        itinerary: {
          title: 'Itinerario giorno per giorno',
          desc: 'Crea un itinerario trascinabile con attività, orari e categorie. Condividilo dal vivo con tutto il gruppo.',
        },
        expenses: {
          title: 'Spese e divisioni',
          desc: 'Registra ogni spesa, dividi i costi nel gruppo e vedi esattamente chi deve a chi con un tocco per saldare.',
        },
        ai: {
          title: 'Ottimizzatore di rotte IA',
          desc: "Indica all'IA le tue preferenze e riordina le tappe per minimizzare il tempo di viaggio. Accetta linguaggio naturale.",
        },
        bookings: {
          title: 'Centro prenotazioni',
          desc: 'Gestisci voli, hotel, trasporti ed eventi in un unico posto. Allega PDF, numeri di riferimento e promemoria.',
        },
        map: {
          title: 'Mappa e luoghi',
          desc: "Scopri luoghi, segnali come visitati e aggiungili al tuo itinerario direttamente dalla vista della mappa.",
        },
        collaborative: {
          title: 'Pianificazione collaborativa',
          desc: 'Invita il tuo gruppo, assegna ruoli e pianificate insieme. Tutti vedono i cambiamenti in tempo reale, senza fogli di calcolo.',
        },
      },
    },
    ai: {
      eyebrow: 'Potenziato dall\'IA',
      headline1: 'Il tuo ottimizzatore',
      headline2: 'di viaggio personale.',
      description: "Racconta all'IA le tue preferenze in linguaggio naturale — orari dei pasti, luoghi imperdibili, come ti piace viaggiare — e ricostruisce la tua giornata in pochi secondi.",
      chips: {
        route: 'Ottimizzazione rotta',
        hints: 'Linguaggio naturale',
        mode: 'Modalità di trasporto',
        grouping: 'Raggruppamento per zona',
      },
      cta: 'Provalo gratis',
    },
    groups: {
      eyebrow: 'Pensato per i gruppi',
      headline1: 'Pianificate insieme,',
      headline2: 'non separati.',
      description: "Invita il tuo gruppo, assegna editor o spettatori, e dividi ogni spesa automaticamente. Un tocco per saldare — senza messaggi imbarazzanti su WhatsApp.",
      features: {
        invite: 'Invitare con un link, gestire i ruoli',
        split: 'Calcolo automatico delle divisioni',
        settle: 'Saldare debiti con un tocco',
        sync: 'Sincronizzazione in tempo reale',
      },
      morePlanning: 'pianificano insieme',
      morePrefix: '+{{count}} altri',
    },
    marketplace: {
      eyebrow: 'Marketplace della comunità',
      headline1: 'Scopri viaggi',
      headline2: 'dalla comunità.',
      description: "Sfoglia itinerari pubblici di viaggiatori da tutto il mondo. Clona qualsiasi viaggio con un clic e adattalo alle tue date, gruppo e budget — senza ripartire da zero.",
      features: {
        browse: 'Sfoglia itinerari pubblici selezionati',
        clone: 'Clona e personalizza qualsiasi viaggio',
        ratings: 'Valutazioni e recensioni della comunità',
        follow: 'Segui i viaggiatori che ammiri',
      },
      cta: 'Esplora la comunità',
      cloneTrip: 'Clonare viaggio',
      nights: '{{country}} · {{count}} notti',
      tripTags: {
        nature: 'Natura',
        culture: 'Cultura',
        adventure: 'Avventura',
        hiking: 'Trekking',
        beach: 'Spiaggia',
        food: 'Cucina',
        souks: 'Souk',
      },
    },
    bottomCta: {
      eyebrow: 'Inizia gratis',
      headline1: 'La tua prossima avventura',
      headline2: 'inizia qui.',
      description: 'Unisciti a migliaia di viaggiatori che pianificano meglio, dividono in modo equo e conservano ricordi migliori.',
      button: 'Crea account gratuito',
      haveAccount: 'Ho già un account',
      fineprint: 'Nessuna carta richiesta · Piano gratuito disponibile per sempre',
    },
    footer: {
      privacy: 'Privacy',
      terms: 'Termini',
      legal: 'Note legali',
      copyright: '© MMXXVI GROMLY · VESTIGI PLATFORM, S.L.',
    },
  },
  explore: {
    toast: {
      loadFailed: 'Impossibile caricare i viaggi',
      tripNotFound: 'Viaggio non trovato',
      ratingFailed: 'Valutazione non riuscita',
      followFailed: "Impossibile aggiornare il follow",
      cloned: 'Viaggio aggiunto al tuo account!',
      cloneFailed: 'Clonazione non riuscita',
      insufficientCredits: 'Nessun credito di viaggio rimasto. Esegui l\'upgrade per ottenerne altri.',
    },
    breadcrumb: 'Community · Modelli',
    heading: 'Esplora viaggi',
    searchPlaceholder: 'Destinazione o viaggio…',
    feed: { all: 'Tutti', following: 'Seguiti' },
    filters: {
      days: 'Giorni', any: 'Qualsiasi', clear: 'Pulisci',
      button: 'Filtri',
      title: 'Filtri',
      sortBy: 'Ordina per',
      destination: 'Destinazione',
      destinationPlaceholder: 'es. Parigi, Italia…',
      nights: 'Notti',
      budgetPerDay: 'Budget al giorno',
      budgetHint: 'Calcolato dalla spesa reale divisa per la durata del viaggio.',
      activities: 'Tipi di attività',
      month: 'Mese del viaggio',
      anyMonth: 'Qualsiasi mese',
      participants: 'Dimensione del gruppo',
      min: 'Min',
      max: 'Max',
      apply: 'Applica',
      reset: 'Reimposta',
      clearAll: 'Cancella tutto',
      activityType: {
        RESTAURANT: 'Ristorante',
        CAFE: 'Caffè',
        MONUMENT: 'Monumento',
        VIEWPOINT: 'Belvedere',
        NEIGHBORHOOD: 'Quartiere',
        PARK: 'Parco',
        SHOP: 'Negozio',
        EXPERIENCE: 'Esperienza',
        TRANSPORT: 'Trasporto',
        PARKING: 'Parcheggio',
        BEACH: 'Spiaggia',
        NATURE: 'Natura',
        ACCOMMODATION: 'Alloggio',
        OTHER: 'Altro',
      },
    },
    sort: { recent: 'Più recenti', topRated: 'Più votati', mostUsed: 'Più usati' },
    results: {
      trips_one: '{{count}} viaggio',
      trips_other: '{{count}} viaggi',
      days_one: '{{count}} giorno',
      days_other: '{{count}} giorni',
    },
    empty: {
      title: 'Nessun viaggio trovato',
      body: "Prova un'altra ricerca o filtro.",
    },
    loadMore: 'Carica altri',
    detail: {
      backToExplore: 'Esplora',
      mapUnavailable: 'Mappa non disponibile',
      allPlaces: 'Tutti i luoghi',
      dayByDay: 'Giorno per giorno',
      dayLabel: 'Giorno {{n}}',
      stops_one: '{{count}} fermata',
      stops_other: '{{count}} fermate',
      calculatingRoute: 'Calcolando il percorso…',
      noStopsToday: 'Nessuna fermata con località in questo giorno.',
      stopFallback: 'Fermata {{n}}',
      openInMaps: 'Apri nella mappa',
      noItinerary: 'Nessun itinerario pianificato.',
      activities_one: '{{count}} attività',
      activities_other: '{{count}} attività',
      noActivities: 'Nessuna attività pianificata',
      noPlaces: 'Nessun luogo elencato.',
      noTips: 'Nessun consiglio condiviso.',
      actualSpend: 'Spesa effettiva',
      tripNotes: 'Note del viaggio',
      useAsTemplate: 'Usa come modello',
      used: 'Usato',
      times_one: '{{count}} volta',
      times_other: '{{count}} volte',
      communityRating: 'Valutazione della community',
      noRatingsYet: 'Nessuna valutazione ancora',
      ratings_one: '{{count}} valutazione',
      ratings_other: '{{count}} valutazioni',
      rateThisTrip: 'Valuta questo viaggio',
      youRated_one: 'Hai valutato {{count}} stella',
      youRated_other: 'Hai valutato {{count}} stelle',
      tripDetails: 'Dettagli del viaggio',
      stats: {
        destination: 'Destinazione',
        dates: 'Date',
        duration: 'Durata',
        people: 'Persone',
        activities: 'Attività',
        nights_one: '{{count}} notte',
        nights_other: '{{count}} notti',
      },
      author: 'Autore',
      publishedAgo: 'Pubblicato {{time}} fa',
      follow: 'Segui',
      following: 'Seguendo',
      travelMode: {
        WALKING: 'A piedi',
        DRIVING: 'Auto',
        BICYCLING: 'Bici',
        TRANSIT: 'Trasporti',
      },
      tabs: {
        itinerary: 'Itinerario',
        places: 'Luoghi',
        map: 'Mappa',
        tips: 'Consigli e info',
        expenses: 'Budget',
        notes: 'Note',
      },
    },
    clone: {
      title: 'Usa come modello',
      tripName: 'Nome del viaggio',
      whenLabel: 'Quando vuoi partire?',
      tripEnds: 'Termina',
      keepOriginalDates: 'Lascia vuoto per mantenere le date originali.',
      addToMyTrips: 'Aggiungi ai miei viaggi',
      daysLabel: 'Giorni da copiare',
      selectAll: 'Tutti',
      clearAll: 'Nessuno',
      selectAtLeastOne: 'Seleziona almeno un giorno',
      untitledDay: 'Giorno senza titolo',
      activitiesCount_one: '{{count}} attività',
      activitiesCount_other: '{{count}} attività',
      summaryDays_one: '{{count}} giorno',
      summaryDays_other: '{{count}} giorni',
      summaryNights_one: '{{count}} notte',
      summaryNights_other: '{{count}} notti',
    },
  },
  pdf: {
    nights_one: '{{count}} notte', nights_other: '{{count}} notti',
    coverLabel: 'Itinerario di viaggio', travellers: 'Viaggiatori', budget: 'Budget', notes: 'Note',
    generatedOn: 'Generato il {{date}}',
    itinerary: 'Itinerario', placesToVisit: 'Luoghi da visitare', bookings: 'Prenotazioni',
    expenses: 'Spese', checklists: 'Checklist', tips: 'Consigli',
    meals: 'Pasti', grocery: 'Lista della spesa',
    flights: 'Voli', hotels: 'Hotel', otherReservations: 'Altre prenotazioni',
    balances: 'Saldi',
    category: 'Categoria', name: 'Nome', zone: 'Zona', address: 'Indirizzo', visited: 'Visitato',
    direction: 'Direzione', route: 'Tratta', departure: 'Partenza', arrival: 'Arrivo',
    flight: 'Volo', ref: 'Rif', outbound: 'Andata', return: 'Ritorno',
    type: 'Tipo', title: 'Titolo', date: 'Data', description: 'Descrizione',
    paidBy: 'Pagato da', amount: 'Importo', owes: 'Deve',
    totalSpent: 'Totale speso', perPerson: 'A persona', checkIn: 'Check-in', checkOut: 'Check-out',
  },
  essentials: {
    heading: "Essenziali per {{country}}",
    currency: "Valuta", language: "Lingua", capital: "Capitale", callingCode: "Prefisso",
    plug: "Corrente", plugType: "Tipo", driving: "Guida", tapWater: "Acqua del rubinetto", emergency: "Emergenze",
    emergencyGeneral: "generale", emergencyPolice: "polizia", emergencyAmbulance: "ambulanza", emergencyFire: "pompieri",
    drive: { left: "A sinistra", right: "A destra" },
    water: { safe: "Potabile", caution: "Con cautela", unsafe: "Bevi in bottiglia" },
    advisory: { normal: "Nessun avviso importante", see_advisory: "Consulta l'avviso di viaggio", avoid_essential: "Evita viaggi non essenziali", avoid_all: "Evita ogni viaggio" },
    practicalDisclaimer: "Informazione indicativa — può variare localmente.",
    visa: {
      visa_free: "Senza visto", visa_on_arrival: "Visto all'arrivo", e_visa: "e-Visto", eta: "Autorizzazione di viaggio", visa_required: "Visto richiesto", no_admission: "Ingresso non consentito",
      upToDays_one: "fino a {{count}} giorno", upToDays_other: "fino a {{count}} giorni",
    },
    requirements: {
      heading: "Requisiti d'ingresso", forNationality: "Per passaporto {{nationality}}",
      forCountry: "Per entrare in {{country}}",
      visa: "Visto", passport: "Passaporto", vaccines: "Vaccini", unknown: "Non disponibile",
      passportValidity_one: "Valido {{count}}+ mese oltre il soggiorno", passportValidity_other: "Valido {{count}}+ mesi oltre il soggiorno", passportValidZero: "Nessuna validità extra oltre il soggiorno",
      noVaccines: "Nessun vaccino richiesto per l'ingresso", mandatory: "Obbligatoria",
      checkedOn: "Verificato il {{date}}", verifyOfficial: "Verifica ufficialmente",
      missingPrompt: "Aggiungi la tua nazionalità per vedere requisiti di visto e vaccini", empty: "Nessun requisito d'ingresso da mostrare",
      disclaimer: "Informazione indicativa, non ufficiale. Le regole d'ingresso e sanitarie cambiano: conferma sempre con il consolato della destinazione o una fonte ufficiale prima di partire.",
    },
  },
  redeemCode: {
    entry: "Ho un codice",
    title: "Apri il tuo viaggio",
    body: "La tua agenzia di viaggi ti ha dato un codice di 8 caratteri. Funziona con l'email che le hai dato: {{email}}.",
    label: "Codice del viaggio",
    submit: "Apri il mio viaggio",
    joined: "Il tuo viaggio è pronto",
    errors: {
      notFound: "Questo codice non corrisponde a nessun invito per {{email}}. Controllalo, e verifica di aver effettuato l'accesso con l'email data alla tua agenzia.",
      emailNotVerified: "Prima verifica la tua email: ti abbiamo inviato un link al momento della registrazione.",
      expired: "Questo codice è scaduto. Chiedine uno nuovo alla tua agenzia.",
      revoked: "La tua agenzia ha annullato questo codice. Chiedine uno nuovo.",
      tooMany: "Troppi tentativi. Riprova tra un'ora.",
      generic: "Non siamo riusciti ad aprire il viaggio. Riprova.",
    },
  },
  agency: {
    card: {
      preparedBy: "Preparato da",
      emergency: "Telefono di emergenza",
      email: "Email",
    },
    managesTravellers: "In questo viaggio i viaggiatori li gestisce la tua agenzia. Chiedile di aggiungere chi manca.",
    panel: {
      tabs: {
        current: "Viaggi",
        past: "Passati",
        templates: "Circuiti",
        clients: "Clienti",
        team: "Team",
        settings: "Impostazioni",
      },
      currentTab: "In corso",
      newTrip: "Nuovo viaggio",
      newTemplate: "Nuovo circuito",
      newDeparture: "Nuova partenza",
      duplicate: "Duplica",
      duplicateName: "{{name}} (copia)",
      duplicateFailed: "Impossibile duplicare il circuito",
      days_one: "{{count}} giorno",
      days_other: "{{count}} giorni",
      nights_one: "{{count}} notte",
      nights_other: "{{count}} notti",
      addDescription: "Aggiungi una descrizione",
      descriptionPlaceholder: "Descrivi il circuito: cosa include, a chi è rivolto…",
      descriptionFailed: "Impossibile salvare la descrizione",
      empty: {
        currentTitle: "Nessun viaggio in corso",
        currentBody: "Crea un viaggio, o una partenza da uno dei tuoi circuiti.",
        pastTitle: "Ancora nessun viaggio passato",
        pastBody: "I viaggi arrivano qui una settimana dopo la fine. Da allora sono dei tuoi clienti.",
        templatesTitle: "Ancora nessun circuito",
        templatesBody: "Un circuito è un viaggio che vendi ancora e ancora. Preparalo una volta e crea una partenza per ogni data.",
      },
      managedUntil: "Lo gestisci fino al {{date}}",
      handedOver: "Del tuo cliente dal {{date}}",
      open: "Apri",
      lead: "Viaggiatore principale",
      status: {
        NOT_INVITED: "Nessun invito",
        INVITED: "Invitato",
        ACTIVATED: "Attivato",
        JOINED: "Unito",
      },
      copyCode: "Copia codice",
      codeCopied: "Codice copiato",
      activations: {
        title: "Viaggiatori attivati",
        count_one: "{{count}} viaggiatore attivato",
        count_other: "{{count}} viaggiatori attivati",
        empty: "Nessuno si è attivato questo mese.",
        month: "Mese",
      },
      usage: {
        title: "Questo mese",
        maps: "Maps: {{used}} di {{cap}}",
        ai: "IA: {{used}} di {{cap}} richieste",
      },
      loadFailed: "Impossibile caricare l'agenzia",
    },
    home: {
      tagline: "Quello che hai tra le mani oggi.",
      stats: {
        ongoing: "In corso",
        leavingSoon: "Partono nei prossimi 7 giorni",
        pending: "Viaggiatori non attivati",
        activated: "Attivati questo mese",
      },
      sections: {
        attention: "Richiede attenzione",
        ongoing: "In corso",
        upcoming: "Prossime partenze",
        activations: "Ultime attivazioni",
        circuits: "Circuiti",
      },
      attentionHint: "Non hanno ancora riscattato il codice, e il viaggio è in corso o parte entro due settimane.",
      allClear: "Ci sono tutti. Al momento niente richiede il tuo intervento.",
      leavesToday: "Parte oggi",
      leavesTomorrow: "Parte domani",
      leavesIn_one: "Parte tra {{count}} giorno",
      leavesIn_other: "Parte tra {{count}} giorni",
      dayOf: "Giorno {{day}} di {{total}}",
      activatedOf: "{{done}}/{{total}} attivati",
      noUpcoming: "Nessuna partenza in programma.",
      noActivations: "Nessuno si è ancora attivato questo mese.",
      allTrips: "Tutti i viaggi",
      seeAll: "Vedi tutte",
      emptyTitle: "La tua agenzia è pronta",
      emptyBody: "Crea il tuo primo viaggio, o un circuito che venderai ancora e ancora.",
    },
    departure: {
      title: "Nuova partenza: {{name}}",
      name: "Nome del viaggio",
      startDate: "Data di inizio",
      travellers: "Viaggiatori",
      leadHint: "Il primo diventa proprietario del viaggio quando usa il suo codice.",
      travellerName: "Nome",
      travellerEmail: "Email (per inviare il codice)",
      addTraveller: "Aggiungi viaggiatore",
      removeTraveller: "Rimuovi",
      submit: "Crea partenza",
      created: "Partenza creata",
      invitesFailed_one: "{{count}} invito non è stato inviato",
      invitesFailed_other: "{{count}} inviti non sono stati inviati",
      failed: "Impossibile creare la partenza",
    },
    settings: {
      brandTitle: "Cosa vedono i tuoi viaggiatori",
      brandHint: "Mostrato nel viaggio finché lo gestisci.",
      name: "Nome dell'agenzia",
      emergencyPhone: "Telefono di emergenza",
      contactEmail: "Email di contatto",
      logo: "Logo",
      uploadLogo: "Carica logo",
      removeLogo: "Rimuovi logo",
      save: "Salva",
      saved: "Salvato",
      saveFailed: "Impossibile salvare",
    },
    clients: {
      title: "Clienti",
      new: "Nuovo cliente",
      edit: "Modifica cliente",
      search: "Cerca per nome o email",
      saveFailed: "Impossibile salvare il cliente",
      loadFailed: "Impossibile caricare il cliente",
      deleteFailed: "Impossibile eliminare il cliente",
      form: {
        name: "Nome",
        email: "Email",
        phone: "Telefono",
        birthDate: "Data di nascita",
        notes: "Note",
        emailInvalid: "Questa email non sembra corretta",
        emailHint: "Senza email viaggia comunque, ma non riceve il codice: qualcuno del gruppo può condividergli il viaggio.",
      },
      picker: {
        noEmail: "Senza email — non riceverà il codice",
        makeLead: "Rendi viaggiatore principale",
        remove: "Rimuovi",
        search: "Cerca tra i tuoi clienti",
        noMatch: "Nessun cliente corrisponde.",
        emptyBook: "Non hai ancora clienti: aggiungi il primo.",
        createNamed: "Nuovo cliente «{{name}}»",
      },
      bornOn: "Nato il {{date}}",
      hasAccount: "Ha un account",
      trips: "Viaggi con voi",
      noTrips: "Ancora nessun viaggio.",
      deleteTitle: "Eliminare {{name}}?",
      deleteBody: "Esce dalla tua rubrica clienti. I suoi viaggi restano suoi.",
      noMatchTitle: "Nessun cliente corrisponde",
      emptyTitle: "Ancora nessun cliente",
      emptyBody: "Ogni viaggiatore che aggiungi a un viaggio arriva qui, così la prossima volta basta sceglierlo.",
      noContact: "Nessun contatto",
      tripCount_one: "{{count}} viaggio",
      tripCount_other: "{{count}} viaggi",
    },
    team: {
      loadFailed: "Impossibile caricare il team",
      lastAdmin: "L'agenzia ha bisogno di almeno un admin.",
      failed: "Qualcosa è andato storto",
      invited: "Invito inviato a {{email}}",
      alreadyMember: "È già nel team.",
      inviteTitle: "Invita nel team",
      inviteHint: "Riceverà un’email ed entrerà quando accetta con quell’indirizzo. I suoi viaggi personali restano suoi.",
      emailPlaceholder: "collega@agenzia.com",
      role: "Ruolo",
      roles: {
        ADMIN: "Admin",
        AGENT: "Agente",
      },
      invite: "Invita",
      you: "(tu)",
      remove: "Rimuovi {{name}}",
      pending: "In attesa",
      revoke: "Annulla invito",
      removeTitle: "Rimuovere {{name}} dal team?",
      removeBody: "Perde l'accesso ai viaggi e ai clienti dell'agenzia. I suoi viaggi personali restano suoi.",
      removeConfirm: "Rimuovi",
    },
    invite: {
      gone: {
        expired: "Questo invito è scaduto",
        used: "Questo invito è già stato usato",
        notFound: "Questo invito non esiste",
      },
      goneBody: "Chiedi all'agenzia di inviartene un altro.",
      goHome: "Vai alla mia home",
      accepted: "Benvenuto in {{agency}}",
      verifyFirst: "Verifica prima la tua email, poi accetta.",
      failed: "Impossibile accettare l'invito",
      eyebrow: "Invito",
      title: "Unisciti a {{agency}}",
      body: {
        ADMIN: "Come admin: prepari i viaggi dei suoi clienti e gestisci il team.",
        AGENT: "Preparerai i viaggi dei suoi clienti.",
      },
      keepTrips: "I tuoi viaggi personali restano tuoi: passi da loro all'agenzia dal menu del tuo profilo.",
      accept: "Accetta e unisciti",
      wrongEmail: "Questo invito è per {{invited}} e hai effettuato l’accesso come {{current}}. Accedi con quell’email per accettarlo.",
    },
    wizard: {
      ask: "Per chi è questo viaggio?",
      hint: "Sceglili tra i tuoi clienti o aggiungine uno nuovo. Il primo è il viaggiatore principale: il viaggio è suo quando riscatta il codice.",
      clientsCount_one: "{{count}} cliente",
      clientsCount_other: "{{count}} clienti",
    },
  },
  admin: {
    loadFailed: "Impossibile caricare. Riprova.",
    acting: { inside: "Sei dentro {{agency}} come Gromly", leave: "Esci", enter: "Entra" },
    usage: {
      subtitle: "Dal {{from}} al {{to}}, rispetto a dal {{prevFrom}} al {{prevTo}}.", subtitleLoading: "Caricamento…",
      rangeLabel: "Periodo", from: "Dal", to: "Al",
      range: { month: "Questo mese", lastMonth: "Mese scorso", "7d": "7 giorni", "30d": "30 giorni", "90d": "90 giorni", "12m": "12 mesi", custom: "Personalizzato" },
      segmentLabel: "Di chi è la spesa", segment: { all: "Tutto", personal: "Viaggi personali", agency: "Viaggi d'agenzia" },
      clearFilter: "Smetti di filtrare per {{name}}", deletedUser: "Account eliminato", deletedTrip: "Viaggio eliminato",
      vsPrevious: "Rispetto al periodo precedente",
      tiles: { total: "Totale", maps: "Maps", ai: "IA", users: "Utenti con spesa", outside: "Fuori dai viaggi", projection: "Proiezione del mese" },
      calls_one: "{{count}} chiamata", calls_other: "{{count}} chiamate",
      aiDetail: "{{calls}} chiamate · {{credits}} crediti", perUser: "{{amount}} per utente",
      outsideDetail: "Ricerca e procedura guidata, prima che il viaggio esista", projectionDetail: "Al ritmo di questo mese",
      trend: "Spesa nel periodo", trendLabel: "Spesa Maps e IA nel periodo",
      byMaps: "Maps per servizio", byAi: "IA per funzione", byModel: "IA per modello",
      topUsers: "Chi spende di più", topTrips: "Viaggi che costano di più", noAgencySpend: "Nessuna spesa d'agenzia in questo periodo",
      split: "Maps {{maps}} · IA {{ai}}", mapsCap: "Tetto Maps {{amount}}/mese",
      empty: "Nessuna spesa in questo periodo",
      footnote: "Registrato dal 27 luglio 2026. La spesa dentro un viaggio d'agenzia conta per l'agenzia (ADR-0034); quella fuori dai viaggi, come personale.",
      maps: { placeResolution: "Trovare luoghi", placeDetails: "Schede dei luoghi", photos: "Foto", search: "Ricerca e completamento", routes: "Percorsi", mapLoads: "Caricamenti mappa", other: "Altro" },
      ai: { chatQuestion: "Chat · domande", chatAction: "Chat · azioni", chatTriage: "Chat · smistamento", chat: "Chat · altro", import: "Importazione documenti", extraction: "Lettura biglietti e scontrini", wizard: "Procedura nuovo viaggio", essentials: "Info sul paese" },
    },
    nav: { overview: "Panoramica", users: "Utenti", agencies: "Agenzie", usage: "Uso e costi" },
    overview: {
      title: "Gromly a colpo d'occhio", subtitle: "Chi lo usa, da dove arriva e quanto costa.",
      signups: "Iscrizioni al mese", trips: "Viaggi creati al mese", seeUsers: "Vedi utenti",
      personalTrips: "Personali", agencyTrips: "Con agenzia", manageAgencies: "Gestisci agenzie",
      footnote: "Gli utenti attivi si contano da quando si è iniziato a registrare l'attività. I viaggi demo e i modelli di agenzia non contano come viaggi.",
      chartLabel: "Grafico mensile: {{series}}",
      activations_one: "{{count}} viaggiatore attivato questo mese", activations_other: "{{count}} viaggiatori attivati questo mese",
      maps: "Maps questo mese", ai: "Richieste IA",
      stats: {
        users: "Utenti", usersDetail_one: "{{count}} nuovo questo mese", usersDetail_other: "{{count}} nuovi questo mese",
        active: "Attivi (30 giorni)", activeDetail_one: "{{count}} negli ultimi 7 giorni", activeDetail_other: "{{count}} negli ultimi 7 giorni",
        pro: "PRO", proDetail_one: "{{count}} in regalo", proDetail_other: "{{count}} in regalo",
        fromAgencies: "Arrivati dalle agenzie", fromAgenciesDetail_one: "{{count}} ha poi creato un viaggio proprio", fromAgenciesDetail_other: "{{count}} hanno poi creato un viaggio proprio",
        trips: "Viaggi", tripsDetail_one: "{{count}} questo mese · {{agency}} con agenzia", tripsDetail_other: "{{count}} questo mese · {{agency}} con agenzia",
        cost: "Costo del mese", costDetail: "Mese scorso: {{amount}}",
      },
    },
    users: {
      total_one: "{{count}} utente", total_other: "{{count}} utenti",
      search: "Cerca per nome, username o email", originLabel: "Origine", anyOrigin: "Qualsiasi origine", tagLabel: "Tipo", anyTag: "Qualsiasi tipo",
      empty: "Nessun utente corrisponde a questi filtri", pagination: "Pagine", prev: "Pagina precedente", next: "Pagina successiva", pageOf: "Pagina {{page}} di {{pages}}",
      origin: { direct: "Diretto", agency: "Tramite agenzia" },
      filter: { staff: "Personale d'agenzia", traveller: "Viaggiatori d'agenzia", pro: "PRO", admin: "Amministratori" },
      tags: { staffOf: "Personale · {{agency}}", travellerOf: "Viaggiatore · {{agency}}", pro: "PRO", proGift: "PRO in regalo", admin: "Admin" },
      cols: { user: "Utente", tags: "Profilo", trips: "Viaggi", joined: "Iscrizione", lastActive: "Ultima attività" },
    },
    user: {
      ownTrips: "Viaggi propri", agencyTrips: "Viaggi con agenzia", usageMonth: "Uso questo mese", usageAll: "Uso totale",
      aiCredits_one: "{{count}} credito IA", aiCredits_other: "{{count}} crediti IA",
      credits: "Crediti rimasti", creditsValue: "{{ai}} IA · {{trips}} viaggi",
      pro: {
        title: "PRO", paid: "Paga PRO ({{source}}) fino al {{date}}. Un PRO pagato non si può regalare sopra né revocare da qui.",
        giftUntil: "PRO in regalo fino al {{date}}.", none: "Non è PRO. Puoi regalarlo fino a una data.",
        presets: "Durata", months_one: "{{count}} mese", months_other: "{{count}} mesi",
        extendMonths_one: "+{{count}} mese", extendMonths_other: "+{{count}} mesi",
        until: "Fino al", grant: "Regala PRO", update: "Cambia data", revoke: "Revoca regalo",
        revokeTitle: "Revocare il PRO in regalo?", revokeBody: "Smette di essere PRO subito. Nulla di ciò che ha creato viene cancellato.",
        granted: "PRO regalato", revoked: "Regalo revocato", alreadyPaid: "Questo utente paga già PRO", failed: "Impossibile salvare la modifica",
        historyGranted: "{{date}} · regalato da {{actor}}", historyRevoked: "{{date}} · revocato da {{actor}}", unknownActor: "un admin eliminato",
        source: { STRIPE: "web", APP_STORE: "App Store", PLAY_STORE: "Google Play" },
      },
    },
  },
  adminAgencies: {
    title: "Agenzie",
    name: "Nome",
    contactEmail: "Email di contatto",
    members: "Personale",
    addMember: "Invita",
    memberEmail: "Email dell'admin dell'agenzia",
    removeMember: "Rimuovi",
    mapsCap: "Tetto Maps (€/mese)",
    aiCap: "Richieste IA / mese",
    activations_one: "{{count}} attivato questo mese",
    activations_other: "{{count}} attivati questo mese",
    downloadCsv: "CSV attivazioni",
    save: "Salva",
    saved: "Salvato",
    empty: "Ancora nessuna agenzia.",
    invited: "Invito inviato a {{email}}",
    alreadyMember: "È già nel team.",
    failed: "Qualcosa è andato storto",
    subtitle: "Le agenzie si registrano a mano. Il loro personale deve prima avere un account Gromly.",
    newTitle: "Nuova agenzia",
    staffEmpty: "Ancora nessun personale: aggiungi l'email di qualcuno con un account Gromly.",
    limitsTitle: "Tetti mensili",
    limitsHint: "Quanto possono spendere in Maps e IA tutti i viaggi dell'agenzia insieme.",
    billingTitle: "Fattura",
    billingHint: "Una riga per ogni viaggiatore attivato nel mese.",
    statMaps: "Maps questo mese",
    statAi: "IA questo mese",
    statActivations: "Attivati questo mese",
    of: "{{used}} di {{cap}}",
    logoHint: "Clicca sul logo per cambiarlo",
  },
} as const;

export default it;
